export const fr = {
  nav: {
    services: "Mandats",
    solutions: "Solutions",
    industries: "Industries",
    work: "Preuves",
    about: "La firme",
    insights: "Perspectives",
    contact: "Contact",
    talkToUs: "Planifier un appel",
    seeWhatWeBuild: "Explorer les systèmes IA de production",
    servicesOverview: "Mandats IA de production",
    industriesOverview: "Adéquation industrie",
    primaryAria: "Navigation principale",
    mobileAria: "Navigation mobile",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
  },
  trustTicker: {
    builtFor: "Secteurs servis",
    items: ["Commerce de détail", "Biens de consommation", "Services professionnels", "Franchises", "Marques DTC"],
  },
  offerCard: {
    learnMore: "Ouvrir la fiche de service",
  },
  cta: {
    talkToUs: "Planifier un appel de cadrage IA",
  },
  home: {
    heroLabel: "IA de production · Fondations données · Systèmes décisionnels",
    heroTitle: "Des systèmes IA de production pour les flux qui doivent produire un impact mesurable.",
    heroSubtitle:
      "Vert AI aide les opérateurs à transformer goulots de flux, données imparfaites et décisions récurrentes en systèmes mesurables, avec revue humaine, monitoring et responsabilité claire.",
    whyUsLabel: "Pourquoi Vert AI",
    whyUsTitle: "Une seule équipe.\nDu cadrage à la production.",
    whyUsSubtitle:
      "Pas de relais entre ceux qui pensent et ceux qui construisent. L’équipe qui cadre le problème est celle qui livre le système.",
    diff1Title: "Une seule équipe, du cadrage au déploiement",
    diff1Desc:
      "Stratégie et ingénierie sous le même toit. La même équipe définit la solution, conçoit l’architecture, écrit le code et met le système en production.",
    diff2Title: "Profondeur technique, jugement commercial",
    diff2Desc:
      "Science des données, ingénierie ML et architecture de systèmes IA, ancrées dans l’économie unitaire et des résultats mesurables. On construit pour faire bouger l’entreprise, pas pour impressionner.",
    diff3Title: "Des systèmes en production, pas des prototypes",
    diff3Desc:
      "Chaque mandat livre un système qui tourne à l’intérieur de votre entreprise. Surveillé, documenté, conçu pour fonctionner sans qu’on regarde par-dessus son épaule.",
    diff4Title: "Engagements de sortie définis",
    diff4Desc:
      "Chaque mandat définit les livrables, critères d’acceptation, risques de production et responsabilités avant d’élargir l’implémentation.",
    engagementsLabel: "Mandats",
    engagementsTitle: "Nos mandats",
    engagementsSubtitle:
      "Cadrés selon le flux, la base de mesure, la réalité des données et la valeur opérationnelle attendue. Livrables et critères d’acceptation inclus.",
    offer1Title: "IA agentique",
    offer1Desc:
      "Automatiser les flux à forte valeur qui consomment votre capacité opérationnelle. Agents encadrés avec routage, contrôles, chemins de repli et supervision humaine, déployés de bout en bout.",
    offer2Title: "IA générative",
    offer2Desc:
      "Transformer le savoir institutionnel et les documents non structurés en réponses fiables. Systèmes ancrés par recherche avec attribution des sources, évaluation et seuils de précision sur lesquels vos équipes peuvent s’appuyer.",
    offer3Title: "IA prédictive",
    offer3Desc:
      "Quantifier ce qui fait bouger le revenu, la rétention et la marge. Modèles de production pour l’attrition, la valeur client, la demande, la recommandation, la propension et la rentabilité, déployés dans les flux où les décisions se prennent.",
    offer4Title: "Plateformes de données",
    offer4Desc:
      "Bâtir la fondation de données dont dépendent votre IA et vos analyses. Architecture source de vérité, couche sémantique, contrôles de qualité et instrumentation de préparation IA conçues pour la confiance.",
    domainsLabel: "Ce qu’on construit",
    domainsTitle: "Les systèmes qu’on déploie.",
    domainsSubtitle:
      "Systèmes IA, données et décision de calibre production pour les flux que les logiciels standards ne couvrent pas pleinement.",
    domain1Label: "Agents IA et automatisation de flux",
    domain1Desc:
      "Réduire le coût manuel des opérations, de la finance et de l’exécution interne. Agents encadrés avec logique de routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
    domain2Label: "Service client et systèmes de soutien",
    domain2Desc:
      "Augmenter la vitesse de résolution et contenir le coût par requête sans sacrifier la qualité. Classification d’intention, réponses ancrées dans le savoir, assistance aux agents et escalade selon le niveau de confiance.",
    domain3Label: "Gestion du savoir et recherche d’entreprise",
    domain3Desc:
      "Récupérer les heures perdues à chercher des réponses. Assistants augmentés par recherche qui raisonnent sur les politiques, procédures, données produit et documentation commerciale, avec attribution des sources.",
    domain4Label: "Intelligence documentaire",
    domain4Desc:
      "Convertir les documents non structurés en données structurées fiables. Extraction, classification, validation et scoring de confiance sur les contrats, propositions, factures et appels d’offres.",
    domain5Label: "Modèles prédictifs et science décisionnelle",
    domain5Desc:
      "Faire passer les décisions commerciales de l’instinct au signal scoré. Modèles de production pour l’attrition, la valeur client, le scoring de prospects, la prévision de demande et la priorisation, déployés dans les flux où l’action se prend.",
    domain6Label: "Recommandation et personnalisation",
    domain6Desc:
      "Augmenter la conversion, le panier moyen et le revenu sur le cycle de vie. Moteurs de recommandation et logique de prochaine meilleure action pour le commerce en ligne, le merchandising et l’expérience client.",
    domain7Label: "Décision de rentabilité et de croissance",
    domain7Desc:
      "Allouer le capital sur le profit réel, pas sur les métriques de plateforme. Systèmes de mesure et de modélisation reliant canal, cohorte, marge de contribution et délai de récupération.",
    domain8Label: "Plateformes de données pour l’IA",
    domain8Desc:
      "Donner à chaque modèle et chaque tableau de bord la même version de la vérité. Architecture source de vérité, couche sémantique, assurance qualité et instrumentation conçues pour la confiance et la traçabilité.",
    domain9Label: "Opérations IA, évaluation et contrôle",
    domain9Desc:
      "Garder l’IA de production sûre, observable et en amélioration. Monitoring, cadre d’évaluation, standards de prompts, contrôles humain-dans-la-boucle, logique d’escalade et garde-fous opérationnels.",
    founderLabel: "Le fondateur",
    founderName: "Guillaume Belisle",
    founderRole: "Fondateur, Vert AI",
    founderP1:
      "Scientifique des données, ingénieur ML et bâtisseur de systèmes IA. L’expérience fondateur de Guillaume inclut la conception et la livraison de systèmes IA, ML et données en production dans des environnements opérateurs incluant Louis Vuitton, Canada Goose, Lowe’s et Home Hardware.",
    founderP2:
      "Il a fondé Vert AI parce que l’industrie sépare presque toujours ceux qui pensent de ceux qui construisent. Ici, c’est la même personne qui cadre le problème, dessine l’architecture, écrit le code et met le système en production.",
    founderP3: "Un seul interlocuteur. Aucun palier intermédiaire. Aucun sous-traitant.",
    founderTags: ["Systèmes IA", "Ingénierie de données", "ML / Science des données", "Systèmes décisionnels", "Mesure de rentabilité"],
    insightsLabel: "Perspectives",
    insightsTitle: "Des idées qui se rendent en production.",
    allInsights: "Toutes les perspectives",
    insightRead: "Lire le guide d’implémentation",
    insight1Cat: "Systèmes IA",
    insight1Title: "Pourquoi les projets IA d’entreprise échouent avant la production.",
    insight1Desc:
      "Le problème est rarement le choix du modèle. Le goulot se trouve dans les flux, les données, la responsabilité, les contrôles et la préparation opérationnelle.",
    insight2Cat: "Ingénierie de données",
    insight2Title: "La couche sémantique est l’actif le plus sous-estimé en IA d’entreprise.",
    insight2Desc:
      "Peu d’entreprises operent une fondation sémantique gouvernée. Sans elle, modèles et tableaux de bord héritent de versions concurrentes de la vérité.",
    insight3Cat: "Science décisionnelle",
    insight3Title: "Vos indicateurs de croissance mentent. Voici quoi mesurer à la place.",
    insight3Desc:
      "Revenu, ROAS et CAC moyen peuvent cacher érosion de marge et dégradation des cohortes. La meilleure mesure part de la contribution et du délai de retour.",
    faqLabel: "Questions fréquentes",
    faqTitle: "Des réponses directes.",
    faq1Q: "Stratégie ou mise en œuvre?",
    faq1A:
      "Les deux, et c’est voulu. On cadre le problème, on conçoit l’architecture, on construit, on déploie. Une seule équipe, du début à la fin. Personne ne reçoit le dossier en relais.",
    faq2Q: "Que veut dire « prêt pour la production »?",
    faq2A:
      "Le système tourne à l’intérieur de votre entreprise. Pas dans un calepin Python. Pas dans un environnement de démo. Déployé, surveillé, documenté et transféré avec procédures d’exploitation et propriétaire désigné.",
    faq3Q: "En quoi Vert AI se distingue des autres firmes IA?",
    faq3A:
      "Profondeur technique et jugement d’affaires dans la même équipe. On ne fait pas de la technologie pour la technologie. On construit des systèmes pensés autour de flux mesurables, de contrôles clairs et de livrables cadrés.",
    faq4Q: "Avec quel type d’entreprise travaillez-vous?",
    faq4A:
      "PDG, chefs d’exploitation, chefs des finances et responsables de données dans des entreprises de taille intermédiaire. Détail, commerce en ligne, services professionnels, réseaux de franchises et entreprises en croissance. Des dirigeants qui veulent des systèmes en production, pas du théâtre IA.",
    faq5Q: "Comment sont tarifés les mandats?",
    faq5A:
      "Cadrés selon le problème. Tarifés selon la valeur attendue. Chaque mandat à des livrables précis, des critères d’acceptation et un échéancier ferme. Aucun forfait à l’heure. Aucun énoncé de travail à périmètre ouvert.",
    faq6Q: "Offrez-vous du support après la mise en service?",
    faq6A:
      "Oui. La Cadence opérationnelle couvre les ajustements, le réentraînement, l’évaluation, l’optimisation de performance et l’évolution de la feuille de route, sur une base récurrente.",
    ctaHeadline: "La prochaine étape, c’est une conversation.",
    ctaDescription:
      "Décrivez le flux, la décision ou le goulot de données. On vous dit ce qu’on construirait d’abord, ce qui doit être vrai et ce qu’un chemin de production pourrait coûter.",
  },
  services: {
    heroLabel: "Mandats",
    heroTitle: "Des mandats IA, données et décision centres sur la valeur opérationnelle.",
    heroSubtitle:
      "Comparez les chemins que Vert AI utilise pour passer de la sélection du flux et de la préparation des données à des systèmes en production avec évaluation, revue humaine, monitoring et impact mesurable.",
    coreLabel: "Les cinq services",
    offer1Title: "IA agentique",
    offer1Desc:
      "Systèmes autonomes encadrés pour les opérations, le support, la finance et l’exécution interne. Routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
    offer2Title: "IA générative",
    offer2Desc:
      "Systèmes augmentés par recherche qui raisonnent sur le savoir institutionnel et les documents non structurés. Sorties ancrées, attribution des sources et précision de calibre production.",
    offer3Title: "IA prédictive",
    offer3Desc:
      "Modèles de production qui scorent, classent, prévoient et quantifient la vérité économique. Attrition, valeur client, demande, recommandation, propension et rentabilité, déployés dans vos flux.",
    offer4Title: "Plateformes de données",
    offer4Desc:
      "L’architecture, la couche sémantique, les contrôles de qualité et la fondation de préparation IA requises avant que l’IA, les analyses ou les systèmes décisionnels puissent opérer de façon fiable.",
    howToChooseLabel: "Par où commencer",
    howToChooseTitle: "Partez du problème.",
    choose1Offer: "Systèmes IA de production",
    choose1Situation:
      "Vous avez un flux ou problème opérationnel concret qui exige un système IA sur mesure jusqu’au déploiement, avec évaluation, monitoring, revue humaine et mesure.",
    choose1Start: "Commencer ici pour les systèmes sur mesure.",
    choose2Offer: "IA agentique et automatisation de flux",
    choose2Situation:
      "Un flux à forte valeur consomme votre capacité opérationnelle, et il vous faut des agents ou automatisations avec outils, contrôles, escalade et revue humaine.",
    choose2Start: "Commencer ici pour les flux autonomes.",
    choose3Offer: "Plateformes de données pour l’IA",
    choose3Situation:
      "Les rapports se contredisent, les initiatives IA bloquant là où l’entreprise a besoin d’entités gouvernées, qualité, définitions sémantiques et activation.",
    choose3Start: "Commencer ici pour l’infrastructure de données.",
    choose4Offer: "Intelligence décisionnelle",
    choose4Situation:
      "Les décisions récurrentes se prennent encore avec tableaux, instinct ou signaux fragmentés, et demandent modèles, règles, seuils, logique de flux et feedback.",
    choose4Start: "Commencer ici pour les décisions récurrentes.",
    choose5Offer: "Diagnostic de préparation IA",
    choose5Situation:
      "Vous avez plusieurs idées IA et devez classer les flux selon valeur, faisabilité, écarts de données, risque d’implémentation et première feuille de route pratique.",
    choose5Start: "Commencer ici avant une construction.",
    processLabel: "Notre façon de travailler",
    processTitle: "Du problème à la production.",
    step1Title: "Cadrage",
    step1Desc:
      "Définir le flux, le responsable, la base de mesure, le risque de production, les livrables, les critères de succès et l’échéancier.",
    step2Title: "Architecture",
    step2Desc:
      "Conception du système, flux de données, plan d’intégration et chemin de déploiement. Avant la moindre ligne de code.",
    step3Title: "Construction",
    step3Desc:
      "Implémentation contre des points de contrôle définis. Travail sur les données, développement de modèles et de systèmes, évaluation, assurance qualité et itération.",
    step4Title: "Déploiement",
    step4Desc:
      "Mise en production, documentation, habilitation de l’équipe, mise en place du monitoring et transfert opérationnel.",
    domainsLabel: "Domaines d’implémentation",
    domainsTitle: "Les solutions que ces mandats livrent.",
    domainsSubtitle:
      "Chaque pilier construit des systèmes IA, données et décision spécifiques à l’intérieur de l’entreprise. Voici les domaines d’implémentation où on opère.",
    domainsGroup1: "IA agentique",
    domainsGroup2: "IA générative",
    domainsGroup3: "IA prédictive",
    domainsGroup4: "Plateformes de données",
    domainsGroupCross: "Transversal · Post-lancement",
    domain1: "Agents IA et automatisation de flux",
    domain2: "Service client et systèmes de soutien",
    domain3: "Gestion du savoir et recherche d’entreprise",
    domain4: "Intelligence documentaire",
    domain5: "Modèles prédictifs et science décisionnelle",
    domain6: "Recommandation et personnalisation",
    domain7: "Décision de rentabilité et de croissance",
    domain8: "Plateformes de données pour l’IA",
    domain9: "Opérations IA, évaluation et contrôle",
    supportLabel: "Après la construction",
    supportTitle: "Support continu.",
    support1Title: "Couche opérateur IA",
    support1Desc:
      "Les contrôles qui gardent les systèmes IA utilisables, monitorés et sûrs en production. Contrôles d’accès, conception humain-dans-la-boucle, règles d’évaluation, logique d’escalade, monitoring et procédures opérationnelles.",
    support2Title: "Cadence opérationnelle",
    support2Desc:
      "Raffinement post-lancement, réentraînement, évaluation, ajustement de performance et expansion de la feuille de route. Offert en niveaux Essentiel, Avancé et Élite avec revues mensuelles.",
    ctaHeadline: "Cartographier le premier flux qui mérite d’être construit.",
    ctaDesc:
      "Aucune présentation requise. Décrivez le flux ou le goulot décisionnel et on cadrera le premier chemin de production utile.",
  },
  agenticAI: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "IA agentique",
    heroSubtitle:
      "Automatiser les flux à forte valeur qui consomment votre capacité opérationnelle. Systèmes d’agents encadrés avec routage, contrôles, chemins de repli et supervision humaine, déployés de bout en bout.",
    heroTimeline: "Agent ciblé : 4–6 sem. · Flux intégré : 6–10 sem. · Système multi-agents : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "La majorité des démos d’agents s’effondrent au premier contact avec les vrais systèmes, les vraies exceptions et la vraie reddition de comptes. L’écart entre un agent qui roule dans un bac à sable et un agent qui opère en sécurité dans une entreprise est un problème d’ingénierie, de gouvernance et de conception humain-dans-la-boucle, pas une limite du modèle.",
    problemP2:
      "Ce mandat comble cet écart avec autonomie encadrée, contrôles réels, déploiement en production et critères d’acceptation écrits.",
    buyersLabel: "Pour qui",
    buyers: [
      "COO ou directeur des opérations dont les flux manuels ne passent pas à l’échelle",
      "CFO ou responsable finance qui automatise routage, validation et gestion d’exceptions",
      "Responsable de l’expérience client qui a besoin de triage et résolution intelligents à fort volume",
      "Leader fonctionnel qui passé de la démo d’agent au système déployé et gouverné",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers la production.",
    phases: [
      {
        num: "01",
        title: "Cadrer le flux et l’économie",
        desc: "Sélection du flux, définition des limites d’autonomie, justification économique, critères de succès et cartographie des responsabilités. Livrable : une note d’une page sur le flux et les critères d’acceptation.",
      },
      {
        num: "02",
        title: "Concevoir l’architecture de l’agent",
        desc: "Conception complète du système : logique de routage, sélection d’outils et d’intégrations, limites de contrôle, chemins de repli et points humain-dans-la-boucle. Livrable : un diagramme d’architecture et un inventaire des outils.",
      },
      {
        num: "03",
        title: "Construire l’orchestration",
        desc: "Câblage des outils, conception des prompts et de l’orchestration, règles d’affaires, gestion des exceptions, logique d’escalade et garde-fous opérationnels. Livrable : un agent fonctionnel sur le périmètre convenu.",
      },
      {
        num: "04",
        title: "Évaluer et durcir",
        desc: "Cas de test, analyse des modes de défaillance, scoring comportemental, critères d’acceptation d’affaires et seuils de fiabilité pour le comportement autonome. Livrable : un rapport d’évaluation et une approbation de fiabilité.",
      },
      {
        num: "05",
        title: "Déployer en production",
        desc: "Mise en production, accès et permissions, exigences de monitoring, pistes d’audit, transfert opérationnel et documentation complète. Livrable : un système en exploitation avec monitoring en place.",
      },
      {
        num: "06",
        title: "Gouverner et faire adopter",
        desc: "Guide utilisateur, procédures opérationnelles, manuels d’escalade et règles de gouvernance pour une opération autonome sûre et durable. Livrable : un manuel d’adoption et un cadre de gouvernance.",
      },
    ],
    useCasesLabel: "Cas d’utilisation courants",
    useCases: [
      "Automatisation de flux opérationnels",
      "Triage et résolution en service client",
      "Routage de demandes internes",
      "Automatisation finance et approvisionnement",
      "Copilotes ventes et opérations",
      "Vérification de conformité et validation",
      "Orchestration multi-étapes avec révision humaine",
      "Flux hybrides règles et LLM",
      "Gestion d’exceptions et escalade",
      "Systèmes multi-agents encadrés",
    ],
    guaranteeLabel: "Standard de livraison",
    guaranteeTitle: "Standard de livraison d’agent en production",
    guaranteeDesc:
      "Le périmètre convenu définit la conception de l’agent, la limite de l’implémentation, le chemin de déploiement, les états de revue et les contrôles opérationnels avant d’élargir la construction.",
    ctaHeadline: "Décrivez le flux.",
    ctaDesc: "On cadrera le système d’agent, les contrôles et le chemin de déploiement.",
  },
  generativeAI: {
    backLink: "← Mandats",
    duration: "4 à 12 semaines",
    heroTitle: "IA générative",
    heroSubtitle:
      "Transformer le savoir institutionnel et les documents non structurés en réponses fiables. Systèmes ancrés par recherche avec attribution des sources, cadre d’évaluation et seuils de précision conçus pour la production.",
    heroTimeline: "Construction ciblée : 4–6 sem. · Multi-source : 6–9 sem. · Déploiement entreprise : 9–12 sem.",
    problemLabel: "Le problème",
    problemP1:
      "L’IA générative sans ancrage est une responsabilité. Réponses hallucinées, citations manquantes et extraction peu fiable depuis les documents ont tué plus de pilotes d’entreprise que toute limite technique. Les systèmes qui fonctionnent sont bâtis sur des architectures de recherche qui ancrent chaque réponse à une source vérifiable et qui sont évalués selon des standards de précision d’affaires, pas des bancs d’essai génériques.",
    problemP2:
      "Ce mandat construit ces systèmes. Ancrés par recherche. Sources attribuées. Évalués pour la production.",
    buyersLabel: "Pour qui",
    buyers: [
      "Responsable des opérations dont les équipes perdent des heures dans les politiques, procédures et données produit",
      "Leader juridique, finance ou approvisionnement qui traite de gros volumes de contrats et de documents",
      "Responsable de l’expérience client qui a besoin d’assistance ancrée et attribuable pour les agents",
      "Leader savoir ou apprentissage qui bâtit des assistants internes pour le personnel",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers des systèmes ancrés.",
    phases: [
      {
        num: "01",
        title: "Cadrer le cas d’usage et cartographier les sources",
        desc: "Périmètre savoir ou documentaire défini, inventaire des sources, cibles de précision, stratégie de recherche et cartographie des responsabilités. Livrable : une carte des sources et une spécification de précision.",
      },
      {
        num: "02",
        title: "Concevoir l’architecture de recherche",
        desc: "Conception d’ingestion, stratégie de découpage et d’plongements, logique de recherche et reranking, règles d’ancrage et modèle d’attribution des sources. Livrable : une architecture de recherche et un plan d’évaluation.",
      },
      {
        num: "03",
        title: "Concevoir la génération et le raisonnement",
        desc: "Structure de prompts et de raisonnement, exigence de citation, gestion du refus et de l’incertitude, schémas de sortie et logique de validation. Livrable : une couche de génération fonctionnelle avec citation imposée.",
      },
      {
        num: "04",
        title: "Évaluer la précision et les citations",
        desc: "Évaluation par jeu de référence, scoring de précision et de citation, analyse des modes de défaillance, seuils d’acceptation d’affaires et conception de rétroaction continue. Livrable : un cadre d’évaluation et une approbation de précision.",
      },
      {
        num: "05",
        title: "Déployer en production",
        desc: "Mise en production, contrôles d’accès, monitoring de dérive et de précision, transfert opérationnel et documentation complète. Livrable : un système en exploitation avec monitoring de dérive en place.",
      },
      {
        num: "06",
        title: "Adopter et améliorer en continu",
        desc: "Guide utilisateur, rapport de lacunes de contenu, boucles de rétroaction et cadence de maintenance pour les sources de savoir sous-jacentes. Livrable : une boucle d’amélioration et un modèle de propriété de contenu.",
      },
    ],
    useCasesLabel: "Cas d’utilisation courants",
    useCases: [
      "Assistants de savoir interne",
      "Recherche de politiques et procédures",
      "Extraction de contrats et de clauses",
      "Traitement de factures et de documents",
      "Génération de réponses aux appels d’offres",
      "Assistants ventes et savoir produit",
      "Revue documentaire de conformité",
      "Systèmes de savoir pour le support technique",
      "Recherche entreprise multi-source",
      "Interfaces conversationnelles sur données privées",
    ],
    guaranteeLabel: "Standard de livraison",
    guaranteeTitle: "Standard de livraison des sorties ancrées",
    guaranteeDesc:
      "Le périmètre convenu définit la couverture de recherche, le comportement des citations, les cas d’évaluation, les seuils de précision et les critères d’acceptation avant mise en ligne.",
    ctaHeadline: "Montrez-nous le problème de savoir.",
    ctaDesc: "On cadrera le système de recherche, les cibles de précision et le chemin de déploiement.",
  },
  predictiveAI: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "IA prédictive",
    heroSubtitle:
      "Quantifier ce qui fait bouger le revenu, la rétention et la marge, et placer ce signal là où les décisions se prennent. Modèles de production pour l’attrition, la valeur client, la demande, la recommandation, la propension et la rentabilité, déployés de bout en bout.",
    heroTimeline: "Modèle ciblé : 4–6 sem. · Système multi-modèle : 6–10 sem. · Déploiement production : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "La majorité des analyses reste descriptive. Les entreprises investissent dans des couches de rapports mais ne construisent jamais les systèmes prédictifs qui améliorent les décisions générant le revenu, la marge et la croissance. Les modèles existants vivent dans des notebooks, n’atteignent jamais les flux où l’action se prend et ne sont jamais évalués selon les résultats d’affaires.",
    problemP2:
      "Ce mandat construit des modèles qui débouchent sur une décision. Scorés, déployés et connectés aux décisions qui font la rentabilité.",
    buyersLabel: "Pour qui",
    buyers: [
      "PDG ou fondateur qui a besoin d’une intelligence commerciale plus fine pour guider l’allocation de capital et la croissance",
      "CFO ou CMO qui dimensionne attrition, valeur client, délai de récupération et mix de canaux",
      "VP Croissance ou responsable science des données qui a besoin de modèles de production, pas de notebooks",
      "Leader merchandising, commerce en ligne ou opérations qui optimise des décisions à fort volume",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers l’utilité décisionnelle.",
    phases: [
      {
        num: "01",
        title: "Cadrer la décision et l’économie",
        desc: "Décision ciblé définie, métrique de succès établie, valeur économique cadrée et cas d’usage sélectionné. Inclut les cadrages de rentabilité et d’allocation de capital lorsque pertinents. Livrable : une note décisionnelle d’une page.",
      },
      {
        num: "02",
        title: "Concevoir le modèle et les variables",
        desc: "Sélection de l’approche de modélisation, ingénierie des variables, conception d’étiquetage, stratégie de validation et compromis précision contre utilisabilité. Livrable : une spécification de variables et un plan de validation.",
      },
      {
        num: "03",
        title: "Entraîner et évaluer",
        desc: "Cadre d’entraînement et de validation, évaluation de performance, vérifications de pertinence d’affaires, logique de seuils et de segmentation, analyse d’erreurs. Livrable : un modèle validé avec performance documentée.",
      },
      {
        num: "04",
        title: "Concevoir le déploiement",
        desc: "Logique de scoring, schéma d’utilisation en production, transfert vers le flux ou la couche décisionnelle, calendrier de réentraînement et monitoring. Livrable : une conception de déploiement avec cadence de réentraînement.",
      },
      {
        num: "05",
        title: "Traduire en interprétation d’affaires",
        desc: "Sens des scores, cadre d’action, guide d’utilisation en aval, mises en garde et notes de fiabilité pour les opérateurs. Livrable : un manuel du score à l’action.",
      },
      {
        num: "06",
        title: "Intégrer à la couche décisionnelle",
        desc: "Connexion au flux, tableau de bord, manuel ou flux où le score est actionné. Pour la rentabilité, inclut la logique de recommandation couper, accélérer ou corriger. Livrable : un système décisionnel en exploitation dans le flux.",
      },
    ],
    useCasesLabel: "Cas d’utilisation courants",
    useCases: [
      "Prédiction d’attrition et intervention",
      "Modélisation de la valeur client",
      "Scoring de prospects et de comptes",
      "Prévision de demande et d’inventaire",
      "Recommandation et prochaine meilleure action",
      "Modèles de propension et segmentation",
      "Support de prix et d’assortiment",
      "Rentabilité et économie par cohorte",
      "Mesure de canal et de délai de récupération",
      "Classification et priorisation opérationnelle",
    ],
    guaranteeLabel: "Standard de livraison",
    guaranteeTitle: "Standard de livraison d’utilité décisionnelle",
    guaranteeDesc:
      "Le périmètre convenu définit la décision ciblée, la limite du modèle ou du scoring, les règles d’interprétation, la conception du déploiement et les métriques de base avant lancement.",
    ctaHeadline: "Nommez la décision.",
    ctaDesc: "On cadrera le modèle, les exigences de données et le chemin de déploiement.",
  },
  dataPlatforms: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "Plateformes de données",
    heroSubtitle:
      "Bâtir la fondation de données dont dépendent votre IA et vos analyses. Architecture source de vérité, couche sémantique, contrôles de qualité et instrumentation de préparation IA, conçues pour la confiance et la traçabilité.",
    heroTimeline: "Ciblé : 4–6 sem. · Multi-source : 6–10 sem. · Environnement élargi : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "Les investissements en IA et en analyses s’effondrent quand les données sous-jacentes sont fragmentées, incohérentes ou peu fiables. Les modèles entraînés sur des données déficientes produisent des décisions déficientes. Les systèmes génératifs récupèrent le mauvais contexte. Les modèles prédictifs s’entraînent sur des variables brisées. Les rapports donnent des réponses différentes selon qui les produit.",
    problemP2:
      "Ce mandat construit la couche de confiance dont dépendent votre IA, vos analyses et votre pile décisionnelle.",
    buyersLabel: "Pour qui",
    buyers: [
      "COO ou CFO qui a besoin de rapports fiables et de données de calibre décisionnel",
      "Responsable données ou leader analytique en charge de la qualité et de la fiabilité des données",
      "Leader RevOps ou Marketing Ops avec des lacunes de mesure qu’il ne peut pas combler",
      "Responsable technique qui prépare l’infrastructure pour le déploiement IA, ML ou génératif",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers des données de calibre décisionnel.",
    phases: [
      {
        num: "01",
        title: "Cartographier l’architecture et les sources",
        desc: "Inventaire des systèmes sources, architecture ciblée, conception source de vérité, cartographie des entités et structure de propriété. Livrable : une carte des sources et un diagramme d’architecture ciblé.",
      },
      {
        num: "02",
        title: "Modéliser les données et la couche sémantique",
        desc: "Modèles de données principaux, logique sémantique, définitions de métriques, plan de transformation et implémentation des règles d’affaires. Livrable : des modèles de données implémentés et un dictionnaire de métriques.",
      },
      {
        num: "03",
        title: "Implémenter les contrôles de qualité et de confiance",
        desc: "Vérifications d’assurance qualité, règles de réconciliation, nettoyage taxonomique, logique d’identité et de déduplication, et remédiation des écarts de confiance. Livrable : une suite de tests qualité et des rapports de réconciliation.",
      },
      {
        num: "04",
        title: "Instrumenter la couche événementielle",
        desc: "Conception de la couche événementielle, capture des étapes de processus, suivi des transferts, journalisation des exceptions et traçabilité. Livrable : un schéma d’événements et l’instrumentation en production.",
      },
      {
        num: "05",
        title: "Préparer la couche IA et ML",
        desc: "Disponibilité des variables, préparation à la recherche pour les systèmes génératifs, classification calibre décisionnel contre directionnel et identification des blocages en amont. Livrable : une évaluation de préparation IA et un catalogue de variables.",
      },
      {
        num: "06",
        title: "Documenter et transférer",
        desc: "Dictionnaire de KPIs, documentation de la logique, notes d’architecture, guide de maintenance et feuille de route pour les systèmes IA en aval. Livrable : un dossier de documentation et une feuille de route en aval.",
      },
    ],
    useCasesLabel: "Problèmes courants qu’on résout",
    useCases: [
      "Systèmes sources déconnectés",
      "Logique de KPIs incohérente entre les équipes",
      "Structure source de vérité fragile",
      "Faible disponibilité de variables pour ML et IA",
      "Confiance brisée envers les rapports",
      "Instrumentation et capture d’événements manquantes",
      "Données d’entrée peu fiables pour les modèles",
      "Aucun modèle de données prêt pour la production",
      "Lacunes de recherche pour les systèmes génératifs",
    ],
    guaranteeLabel: "Standard de livraison",
    guaranteeTitle: "Standard de livraison de données décisionnelles",
    guaranteeDesc:
      "Le périmètre convenu définit la structure source de vérité, la logique de données principale, les contrôles qualité, le modèle de responsabilité et la documentation requise pour l’acceptation.",
    ctaHeadline: "Commencez par les données.",
    ctaDesc: "Décrivez votre environnement de données. On cadrera l’architecture et le chemin vers la fiabilité.",
  },
  about: {
    heroLabel: "À propos de Vert AI",
    heroTitle: "Concu pour l’écart entre l’ambition IA et la réalité de la production.",
    heroSubtitle:
      "Vert AI aide les opérateurs à transformer les flux de travail à forte valeur, les données imparfaites et les goulots de décision en systèmes IA de production avec chemins de revue, responsabilité et valeur opérationnelle mesurable.",
    secondaryCta: "Explorer les systèmes IA de production",
    heroProof: [
      {
        label: "IA de production, pas prototypes",
        desc: "Le travail est cadré autour de vrais flux, de la préparation des données, de l’évaluation, du monitoring et de l’adoption.",
      },
      {
        label: "Livraison dirigée par le fondateur",
        desc: "Le cadrage dirigé par le fondateur et l’implication technique senior restent proches de l’architecture, de la qualité de construction et des décisions de production.",
      },
      {
        label: "Mesure avant construction",
        desc: "Les métriques de départ, contraintes opérationnelles et critères de succès sont définis avant d’élargir l’implémentation.",
      },
    ],
    whyExistsLabel: "Pourquoi Vert existe",
    whyExistsTitle: "La plupart des entreprises n’ont pas besoin d’autres expérimentations IA.",
    whyExistsP1:
      "Elles ont besoin de meilleures décisions, de flux de travail plus propres, de fondations de données fiables et de systèmes qui peuvent être surveillés après le lancement.",
    whyExistsP2:
      "Vert AI existe pour les opérateurs qui ont dépassé l’inspiration IA et qui ont besoin de discipline d’implémentation : choisir le bon flux, exposer les écarts de données, définir la base de mesure, construire le système et le garder responsable en production. Tous les flux ne devraient pas être automatisés.",
    principlesLabel: "Principes",
    principlesTitle: "Comment Vert AI décide ce qui mérite d’être construit.",
    principles: [
      {
        title: "Commencer par les flux coûteux, pas les démos technologiques.",
        desc: "La première question est où la vitesse, la qualité, le coût ou la précision décisionnelle créent déjà une pression mesurable.",
      },
      {
        title: "Définir la base de mesure avant de construire.",
        desc: "Temps de cycle, taux d’exception, effort de revue, coût d’erreur, adoption et qualité de décision doivent avoir un point de départ.",
      },
      {
        title: "Rendre la préparation des données visible.",
        desc: "Qualité source, responsabilité, permissions, sémantique et instrumentation manquante sont exposées avant de devenir des risques de production.",
      },
      {
        title: "Garder les humains en contrôle lorsque le risque, le jugement ou l’impact client comptent.",
        desc: "L’IA doit router, recommander, rédiger, récupérer et scorer avec des chemins de revue clairs lorsque l’imputabilité, la confidentialité ou l’expérience client comptent.",
      },
      {
        title: "Concevoir pour la production dès le premier jour.",
        desc: "Évaluation, observabilité, logique de repli, contrôle d’accès et responsabilité opérationnelle font partie du design système.",
      },
      {
        title: "Mesurer l’adoption et l’impact opérationnel.",
        desc: "Un système ne réussit pas parce qu’il est lancé. Il réussit quand les gens l’utilisent et que le flux s’améliore.",
      },
      {
        title: "Élargir seulement après avoir gagné la confiance.",
        desc: "Le prochain flux doit venir après que le premier prouve sa fiabilité, son adoption et son utilité business.",
      },
    ],
    differenceLabel: "Ce qui rend le travail différent",
    differenceTitle: "Stratégie, données, flux et ingénierie de production restent connectés.",
    differenceItems: [
      {
        title: "Stratégie et construction dans la même équipe.",
        desc: "Les personnes qui formulent la recommandation restent proches de l’architecture, de l’implémentation et des contraintes de lancement.",
      },
      {
        title: "IA + données + flux + logique décisionnelle.",
        desc: "Une IA utile dépend souvent de chemins de données propres, de règles explicites, d’interfaces utilisables et d’une conception des escalades.",
      },
      {
        title: "Contrôles de production inclus.",
        desc: "Évaluation, monitoring, auditabilité, revue humaine et comportements de repli sont traités comme du périmètre central.",
      },
      {
        title: "Responsabilité et gouvernance claires.",
        desc: "Chaque système a besoin de responsables pour les données, la logique, la revue, la performance et la gestion du changement.",
      },
    ],
    trustLabel: "Confiance et discipline opérationnelle",
    trustTitle: "La confiance se construit dans le système, pas au lancement.",
    trustIntro:
      "L’IA de production doit être inspectable. Vert AI traite l’évaluation, le monitoring, les escalades, la qualité des données, la confidentialité, la revue sécurité, la responsabilité, l’adoption et la mesure du ROI comme des exigences d’implémentation.",
    trustItems: [
      {
        title: "Évaluation",
        desc: "Jeux de test, critères d’acceptation, cas limites et boucles de revue sont définis pour juger le système honnêtement.",
      },
      {
        title: "Monitoring",
        desc: "Usage, qualité, latence, dérive, modes de défaillance et métriques business doivent rester visibles après le lancement.",
      },
      {
        title: "Logique d’escalade",
        desc: "Seuils de confiance, routage d’exception et chemins de revue humaine gardent le jugement au bon endroit.",
      },
      {
        title: "Qualité des données",
        desc: "Intrants, transformations, définitions et responsabilités sont explicites pour éviter que le système hérite d’ambiguïté cachée.",
      },
      {
        title: "Confidentialité et sécurité",
        desc: "Accès, permissions, données sensibles, exposition fournisseur et revue sécurité sont considérés avant d’automatiser les flux.",
      },
      {
        title: "Gouvernance",
        desc: "Contrôle des changements, documentation, responsabilité et cadence de revue gardent le système utile quand l’entreprise change.",
      },
    ],
    founderLabel: "Le fondateur",
    founderName: "Guillaume Belisle",
    founderRole: "Fondateur, Vert AI",
    founderTitle: "Livraison dirigée par le fondateur, avec implication technique senior proche du travail.",
    founderP1:
      "Guillaume Belisle est scientifique des données, ingénieur ML et bâtisseur de systèmes IA. Son expérience fondateur comprend la conception et la livraison de systèmes IA, ML et données en production dans des environnements opérateurs incluant Louis Vuitton, Canada Goose, Lowe’s, Home Hardware et d’autres organisations où une implémentation ratée porte un vrai coût opérationnel.",
    founderP2:
      "Vert AI est construit pour une implication senior directe : cadrer le flux, tester la fondation de données, définir l’architecture système et revoir ce qui part en production.",
    founderP3:
      "Le biais opérationnel est commercial et technique à la fois. Si un système ne peut pas être mesuré, gouverné, adopté et utilisé avec confiance, il n’est pas prêt.",
    founderP4:
      "La même discipline opérationnelle guide les nouveaux mandats : flux cadrés, base de mesure claire, évaluation, observabilité, revue humaine, gouvernance et mesure business.",
    ctaHeadline: "Apportez le flux qui doit devenir mesurable.",
    ctaDesc:
      "Utilisez l’appel de cadrage pour tester si l’opportunité est prête pour un système IA de production, un chantier de fondation données, une automatisation plus ciblée ou aucun build pour l’instant.",
  },
  insights: {
    heroLabel: "Perspectives",
    heroTitle: "Des idées qui se rendent en production.",
    heroSubtitle:
      "Guides acheteurs et notes de terrain pour opérateurs qui évaluent systèmes IA de production, fondations de données, contrôles de flux et qualité décisionnelle mesurable.",
    featured: "À la une",
    readArticle: "Lire le guide opérationnel",
    articles: [
      {
        cat: "IA de production",
        title: "Pourquoi les pilotes IA échouent avant la production",
        desc: "Les pilotes IA échouent souvent avant la production parce que le flux, les données, le responsable, les contrôles, l’intégration et la base de mesure n’ont jamais été rendus explicites. Un diagnostic opérationnel pour passer du prototype à la capacité déployée.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "pilotes IA échouent, IA de production, preuve de concept IA, préparation déploiement IA, responsabilité flux IA, contrôles IA production",
        tags: ["IA de production", "Pilotes IA", "Design de flux", "Préparation données", "Gouvernance IA"],
      },
      {
        cat: "Préparation IA",
        title: "La checklist de préparation IA de production pour entreprises mid-market",
        desc: "Une checklist pratique pour opérateurs mid-market : valeur du flux, fréquence de décision, disponibilité et qualité des données, responsabilité, risque, revue humaine, intégration et base de mesure.",
        date: "Juillet 2026",
        readTime: "9 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "checklist préparation IA, IA mid-market, préparation IA production, évaluation opportunité IA, checklist flux IA",
        tags: ["Préparation IA", "Mid-market", "IA de production", "Évaluation de flux", "Scorecard IA"],
      },
      {
        cat: "Systèmes décisionnels",
        title: "Intelligence décisionnelle vs business intelligence",
        desc: "La business intelligence explique ce qui s’est passé. L’intelligence décisionnelle aide les opérateurs à décider quoi faire ensuite, avec données, règles, IA, logique de flux, rétroaction et responsabilité intégrées.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "intelligence décisionnelle vs business intelligence, BI vs systèmes décisionnels, moteur décisionnel, analytique opérationnelle, systèmes décisionnels IA",
        tags: ["Intelligence décisionnelle", "Business intelligence", "Systèmes décisionnels", "Analytique", "Flux"],
      },
      {
        cat: "Automatisation de flux",
        title: "Comment choisir le premier flux IA à automatiser",
        desc: "Le premier flux IA devrait être valuable, fréquent, borné, mesurable, révisable et connecté à des données utilisables. Un cadre de sélection pour éviter le théâtre d’automatisation coûteux.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "automatisation flux IA, choisir cas usage IA, premier flux IA, critères automatisation flux, sélection opportunité IA",
        tags: ["Automatisation de flux", "Cas d’usage IA", "Préparation IA", "Levier opérationnel", "IA de production"],
      },
      {
        cat: "Gouvernance IA",
        title: "Gouvernance IA pour opérateurs : monitoring, évaluation et revue humaine",
        desc: "La gouvernance IA pour opérateurs n’est pas du théâtre de comité. C’est la couche opérationnelle de monitoring, évaluation, escalade, revue humaine, qualité des données, sécurité, responsabilité et retour arrière.",
        date: "Juillet 2026",
        readTime: "9 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "gouvernance IA opérateurs, monitoring IA, évaluation IA, revue humaine IA, escalade IA, gouvernance IA production",
        tags: ["Gouvernance IA", "Monitoring", "Évaluation", "Revue humaine", "Contrôles de production"],
      },
      {
        cat: "IA agentique",
        title: "Ce que l’IA agentique devrait automatiser, et ce qu’elle ne devrait pas automatiser",
        desc: "L’IA agentique devrait automatiser la coordination bornée, le routage, la rédaction, la recherche, la classification et le suivi. Elle ne devrait pas posséder le jugement à risque élevé, les exceptions de politique ou les décisions commerciales irréversibles sans contrôle humain.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "automatisation IA agentique, agents IA flux, ce que les agents IA devraient automatiser, humain dans la boucle agents, gouvernance agents IA",
        tags: ["IA agentique", "Agents IA", "Automatisation de flux", "Revue humaine", "Gouvernance"],
      },
      {
        cat: "Plateformes de données",
        title: "La fondation de données derrière les systèmes IA utiles",
        desc: "Une IA utile dépend d’une fondation de données avec responsabilité des sources, définitions sémantiques, contrôles qualité, accès, fraîcheur, lignage et chemins d’activation dans le flux.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "fondation données IA, données prêtes IA, plateformes données IA, couche sémantique, qualité données IA, données IA production",
        tags: ["Plateformes de données", "Données prêtes IA", "Couche sémantique", "Qualité des données", "IA de production"],
      },
      {
        cat: "Économie IA",
        title: "Comment mesurer le ROI avant de construire un système IA",
        desc: "Le ROI IA doit être mesuré avant la construction en définissant la base actuelle, le mouvement ciblé, le chemin d’adoption, le coût de revue, le coût d’implémentation et la métrique opérationnelle à améliorer.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "mesure ROI IA, dossier d’affaires IA, métriques de base IA, mesurer valeur IA, ROI implémentation IA",
        tags: ["ROI IA", "Dossier d’affaires", "Mesure", "Économie IA", "Base de mesure"],
      },
      {
        cat: "Systèmes décisionnels",
        title: "Du tableau de bord au moteur décisionnel : ce qui change en production",
        desc: "Un tableau de bord informe un humain. Un moteur décisionnel transforme les données en action recommandée, routée et monitorée. Le passage en production exige règles, seuils, responsabilité, rétroaction et contrôles.",
        date: "Juillet 2026",
        readTime: "8 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "tableau de bord vers moteur décisionnel, moteur décisionnel, intelligence décisionnelle, systèmes décisionnels production, analytique opérationnelle",
        tags: ["Moteurs décisionnels", "Intelligence décisionnelle", "Business intelligence", "Flux", "IA de production"],
      },
      {
        cat: "Stratégie IA",
        title: "Pourquoi le théâtre IA coûte cher",
        desc: "Le théâtre IA coûte cher parce qu’il consomme attention exécutive, capacité de l’équipe données, budget fournisseur et confiance des opérateurs sans améliorer un flux, une décision, une base de mesure ou un résultat business mesurable.",
        date: "Juillet 2026",
        readTime: "7 min de lecture",
        author: "Guillaume Belisle / Vert AI",
        keywords: "théâtre IA, stratégie IA, projets IA échoués, valeur IA production, levier opérationnel IA, démos IA",
        tags: ["Stratégie IA", "Théâtre IA", "IA de production", "Levier opérationnel", "ROI IA"],
      },
      {
        cat: "Stratégie IA",
        title: "Le piège de l’approvisionnement IA : ces contrats 2026 hypothèquent votre feuille de route.",
        desc: "Quatre clauses structurelles dans les contrats IA d’entreprise standards paraissent raisonnables en revue juridique et deviennent catastrophiques en année deux : frais de sortie, verrouillage de version, portabilité des plongements et regroupement de fonctionnalités IA. La liste de vérification à exécuter avant de signer.",
        date: "Mai 2026",
        readTime: "9 min de lecture",
        keywords: "contrat fournisseur IA, verrouillage fournisseur IA, approvisionnement IA entreprise, clauses contrats IA, modèles de fondation contrats, évaluation fournisseur IA, frais de sortie IA, négociation IA",
        tags: ["Approvisionnement IA", "Stratégie fournisseur", "IA d’entreprise", "Contrats IA", "Verrouillage fournisseur"],
      },
      {
        cat: "Opérations IA",
        title: "La supervision humaine n’est pas un filet de sécurité. C’est une ligne de P&L.",
        desc: "Chaque flux augmenté par l’IA est une réallocation de main-d’œuvre. L’économie ne tient que si le temps de revue, le taux d’escalade et le seuil de confiance sont conçus ensemble. Un modèle de coûts à trois variables, et où les équipes brûlent le gain de productivité dans les files de revue.",
        date: "Avril 2026",
        readTime: "8 min de lecture",
        keywords: "supervision humaine IA, flux de revue IA, coûts opérations IA, économie HITL, seuil de confiance IA, taux d’escalade IA, flux augmenté par IA, modèle de main-d’œuvre IA",
        tags: ["Opérations IA", "Supervision humaine", "Économie IA", "Conception de flux", "IA en production"],
      },
      {
        cat: "Systèmes IA",
        title: "Le déficit d’évaluation : pourquoi la plupart des systèmes IA n’ont aucun tableau de bord honnête.",
        desc: "Le score F1, le BLEU et la satisfaction utilisateur ne sont pas des indicateurs commerciaux. L’architecture d’évaluation en quatre couches, hors ligne, en miroir, déploiement contrôlé et dérive en production, qui sépare les démos des systèmes que la direction peut défendre au conseil.",
        date: "Avril 2026",
        readTime: "8 min de lecture",
        keywords: "évaluation IA, indicateurs IA entreprise, surveillance de modèles, tableau de bord IA, évaluation en miroir, détection de dérive IA, évaluation IA en production, évaluation LLM",
        tags: ["Évaluation IA", "IA d’entreprise", "Surveillance de modèles", "Opérations IA", "IA en production"],
      },
      {
        cat: "Systèmes IA",
        title: "Construire ou acheter en IA. Le cadre décisionnel 2026.",
        desc: "Les modèles de fondation sont devenus des commodités. L’orchestration est le vrai facteur différenciant. Un modèle décisionnel à trois axes, levier des données propriétaires, spécificité du flux de travail et horizon de défense, pour arbitrer entre SaaS IA, assemblage et systèmes sur mesure.",
        date: "Mars 2026",
        readTime: "7 min de lecture",
        keywords: "construire ou acheter IA, stratégie IA entreprise, cadre décisionnel IA, modèles de fondation, assemblage de pile IA, IA propriétaire, évaluation fournisseur IA, défensibilité IA",
        tags: ["Stratégie IA", "Construire ou acheter", "IA d’entreprise", "Architecture IA", "Sélection de fournisseurs"],
      },
      {
        cat: "Systèmes IA",
        title: "Pourquoi les projets IA d’entreprise échouent avant la production.",
        desc: "Le goulot est rarement le choix du modèle. Il se trouve dans les flux, l’architecture données, la responsabilité opérationnelle, les contrôles et la préparation.",
        date: "Mars 2026",
        readTime: "8 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "La couche sémantique est l’actif le plus sous-estimé en IA d’entreprise.",
        desc: "Peu d’entreprises operent une fondation sémantique gouvernée. Sans elle, modèles et tableaux de bord héritent de versions différentes de la vérité.",
        date: "Février 2026",
        readTime: "7 min de lecture",
      },
      {
        cat: "Science décisionnelle",
        title: "Vos indicateurs de croissance mentent. Voici quoi mesurer à la place.",
        desc: "Revenu, ROAS et CAC moyen peuvent cacher érosion de marge et dégradation des cohortes. Une approche décisionnelle mesure contribution, retour et qualité.",
        date: "Janvier 2026",
        readTime: "6 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title:
          "L’IA agentique en production. Pourquoi beaucoup de déploiements vont bloquer.",
        desc: "L’adoption de l’IA agentique avance plus vite que la discipline opérationnelle. Les lacunes de gouvernance, d’évaluation et de flux séparent les démos des systèmes déployés.",
        date: "Décembre 2025",
        readTime: "9 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "Vos données ne sont pas prêtes pour l’IA. Cinq signaux diagnostiques.",
        desc: "Avant d’investir dans les modèles, faites passer ce diagnostic. Cinq signaux structurels, de la fragilité des pipelines à la dérive sémantique, qui prédisent si votre couche de données va propulser l’IA ou la saboter.",
        date: "Novembre 2025",
        readTime: "5 min de lecture",
      },
      {
        cat: "Intelligence de rentabilité",
        title:
          "La couche de coûts invisible derrière les calculs de ROI IA.",
        desc: "Gestion du changement, préparation des données, intégration et frais opérationnels restent souvent hors du dossier d’affaires. Comment construire un modèle de coûts honnête.",
        date: "Octobre 2025",
        readTime: "7 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title: "L’écart entre un modèle entraîné et un système de production est un problème d’ingénierie.",
        desc: "Un modèle dans un notebook n’est pas un système. Monitoring, versionnage, logique de repli et échafaudage opérationnel séparent une démo d’une capacité déployée. La plupart des équipes ML ne sont pas outillées pour combler cet écart.",
        date: "Septembre 2025",
        readTime: "6 min de lecture",
      },
      {
        cat: "Science décisionnelle",
        title: "Couches décisionnelles. L’architecture manquante entre les données et l’action.",
        desc: "La plupart des entreprises ont des tableaux de bord. Très peu ont des systèmes décisionnels. Le schéma architectural qui relié modèles prédictifs, règles d’affaires et flux opérationnels en systèmes qui génèrent de l’action, pas des rapports.",
        date: "Août 2025",
        readTime: "7 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "De l’ETL au pile IA-native. Le vrai visage de l’infrastructure données en 2026.",
        desc: "La pile de données moderne est morte. La pile de données IA-native, temps réel, riche en contexte et gouverné sémantiquement, est ce que l’IA de production exige. Un plan architectural pour les équipes données qui construisent pour les systèmes agentiques.",
        date: "Juillet 2025",
        readTime: "8 min de lecture",
      },
      {
        cat: "Intelligence de rentabilité",
        title:
          "L’allocation de capital est un problème de données. La plupart des entreprises le règlent avec des opinions.",
        desc: "Où dépenser, où couper, où accélérer. Ce sont des questions de mesure, pas de stratégie. Les entreprises qui traitent l’allocation de capital comme un problème d’ingénierie de données surperforment systématiquement les autres.",
        date: "Juin 2025",
        readTime: "6 min de lecture",
      },
    ],
  },
  contact: {
    heroLabel: "Contact",
    heroTitle: "Apportez le flux. Repartez avec une prochaine étape pratique.",
    heroSubtitle:
      "Partagez le flux, la décision ou le problème de données que vous voulez améliorer. Vert AI aidera à déterminer si la prochaine étape est un système IA de production, une fondation données, une automatisation, une couche décisionnelle ou aucun build pour l’instant.",
    bookingLabel: "Prochaine étape principale",
    bookingTitle: "Planifier un appel de cadrage IA",
    bookingDesc:
      "Utilisez l’appel pour tester si l’opportunité est assez concrète pour être construite, quel travail de données ou de flux doit venir d’abord, et si la première réponse utile est de ne pas automatiser encore.",
    bookingMeta: "Conversation de cadrage dirigée par le fondateur",
    fallbackBooking: "Partager le contexte projet",
    howToReach: "Contact alternatif",
    scopingCall: "Partagez le contexte si vous n’êtes pas prêt à réserver.",
    scopingCallDesc:
      "Vous préférez le courriel ou voulez partager des détails d’abord? Envoyez le contexte ci-dessous. Chaque demande est revue directement et reçoit une prochaine étape pratique.",
    emailLabel: "Courriel",
    locationLabel: "Bureau",
    location: "Montréal, Canada",
    responseTimeLabel: "Temps de réponse",
    responseTime: "Un jour ouvrable",
    formLabel: "Qualification du projet",
    formTitle: "Dites-nous quel flux mérite d’être améliore.",
    formIntro:
      "Partagez assez de contexte pour comprendre le flux, la décision, la fondation de données, les contraintes et le calendrier. Si la bonne réponse est de ne pas construire encore, Vert AI le dira.",
    formName: "Nom",
    formNamePlaceholder: "Votre nom",
    formRole: "Votre rôle",
    formRolePlaceholder: "Fondateur, COO, VP Opérations, responsable données...",
    formCompany: "Entreprise ou groupe opérationnel",
    formCompanyPlaceholder: "Nom de l’entreprise",
    formEmail: "Courriel professionnel",
    formEmailPlaceholder: "vous@entreprise.com",
    formWebsite: "Site web",
    formWebsitePlaceholder: "https://entreprise.com",
    formMessage: "Flux, décision ou problème de données",
    formMessagePlaceholder:
      "Décrivez le flux, la décision ou le problème de données. Incluez ce qui se passe aujourd’hui, ce qui bloqué et l’amélioration qui compterait.",
    formNeed: "Chemin de projet le plus proche",
    formNeedPlaceholder: "Selectionnez le meilleur fit",
    formTimeline: "Moment de décision",
    formTimelinePlaceholder: "Selectionnez le moment",
    formCompanySize: "Contexte opérationnel",
    formCompanySizePlaceholder: "Taille d’équipe, stade de revenus, nombre de sites, volume de tickets, échelle des données ou systèmes existants...",
    formOptional: "Facultatif",
    formSubmit: "Envoyer le contexte du flux",
    formSending: "Envoi du contexte...",
    formSuccessTitle: "Contexte reçu.",
    formSuccessDesc:
      "Vert AI examinera le contexte du flux et répondra sous un jour ouvrable avec un chemin d’appel, une question de clarification ou une recommandation de ne pas construire tout de suite.",
    formErrorTitle: "La demande n’a pas pu être envoyée.",
    formErrorDesc:
      "Réessayez, planifiez un appel de cadrage ou envoyez le même contexte de flux par courriel.",
    validationRequired: "Ajoutez ce detail avant l’envoi.",
    validationEmail: "Entrez un courriel professionnel validé.",
    needOptions: [
      "Automatisation de flux IA",
      "Plateforme de données pour l’IA",
      "Intelligence décisionnelle",
      "Préparation IA / cartographie des opportunités",
      "Pas certain pour l’instant",
    ],
    timelineOptions: ["Maintenant", "Ce trimestre", "Prochains 6 mois", "Exploration"],
    reassuranceLabel: "Reassurance de qualification",
    reassuranceTitle: "Une vraie première conversation, pas un audit IA générique.",
    reassurance: [
      {
        title: "Première conversation dirigée par le fondateur",
        desc: "La première revue reste proche de la personne responsable de la direction technique, du cadrage fondateur et des standards de livraison.",
      },
      {
        title: "Aucun audit IA générique",
        desc: "La conversation part du flux, de la décision, des données et de l’économie, pas d’une liste de verification recyclee.",
      },
      {
        title: "Prochaines étapes claires",
        desc: "S’il y a un fit, la prochaine étape est un chemin cadré avec hypothèses, risques, données requises et livrables attendus.",
      },
      {
        title: "Recommandation pratique",
        desc: "Si la meilleure réponse est de ne pas construire tout de suite, Vert AI le dira et identifiera ce qu’il faut regler d’abord.",
      },
    ],
    faqLabel: "FAQ",
    faqTitle: "Questions fréquentes avant un appel de cadrage.",
    faqs: [
      {
        q: "Que se passe-t-il après l’envoi?",
        a: "Vert AI examine le flux, les données, le calendrier et les signaux de fit. Vous recevez une réponse pratique sous un jour ouvrable avec un chemin d’appel, une question de clarification ou une recommandation de ne pas construire tout de suite.",
      },
      {
        q: "Avons-nous besoin d’un cas d’usage défini?",
        a: "Non. Un flux approximatif, une décision récurrente, un goulot de données ou une friction opérationnelle suffit pour commencer. Vert AI peut aider à déterminer si cela devrait devenir un projet IA, données, automatisation ou intelligence décisionnelle.",
      },
      {
        q: "Pouvez-vous travailler avec notre pile existante?",
        a: "Habituellement, oui. La première étape est de comprendre les systèmes actuels, l’accès aux données, les contraintes d’intégration, les exigences de sécurité et confidentialité et qui possédera le flux après lancement.",
      },
      {
        q: "Signez-vous des NDA?",
        a: "Oui, lorsque la confidentialité est requise avant de partager du contexte technique ou opérationnel détaillé.",
      },
      {
        q: "Travaillez-vous avec des équipes hors Canada?",
        a: "Oui. Vert AI est basée au Canada et travaille avec des opérateurs nord-américains, y compris des équipes hors Canada.",
      },
    ],
  },
  work: {
    heroLabel: "Schémas de travail",
    heroTitle: "Comment un mandat IA devient crédible avant de passer à l’échelle.",
    heroSubtitle:
      "Vert AI utilise des schémas de travail cadrés, des bases de mesure, l’évaluation, le monitoring, la revue humaine et la gouvernance pour transformer les opportunités IA, données et décision en systèmes de production inspectables.",
    operatingLabel: "Ce qui compte comme travail",
    operatingTitle: "Un système livre, pas une démo polie.",
    operatingIntro:
      "Le travail doit survivre aux vraies données, aux vrais utilisateurs, aux exceptions, aux relais, au monitoring et à la responsabilité opérationnelle. C’est le seuil pour dire qu’un mandat est terminé.",
    operatingPrinciples: [
      {
        title: "Partir du flux et de la décision",
        desc: "On identifie le moment opérationnel où l’IA, les données ou la logique décisionnelle peuvent changer le débit, la qualité, la marge ou la vitesse.",
      },
      {
        title: "Concevoir autour des contraintes de production",
        desc: "Qualité des données, intégrations, confidentialité, sécurité, files de révision, escalades et adoption sont cadrées avant l’implémentation.",
      },
      {
        title: "Évaluer avant et après la mise en ligne",
        desc: "Le système est testé contre le comportement attendu, les modes d’échec, les critères business et les besoins de transfert avant de devenir une capacité opérationnelle.",
      },
      {
        title: "Laisser des preuves opérationnelles",
        desc: "Architecture, contrôles, documentation, responsabilités et mesure sont assez visibles pour être inspectés par la direction et les équipes.",
      },
    ],
    evidenceLabel: "Preuves de livraison",
    evidenceTitle: "Ce qu’un acheteur sérieux devrait voir.",
    evidenceIntro:
      "Chaque mandat produit des artefacts différents, mais un travail IA de production devrait laisser une trace claire sur le fonctionnement, la gouvernance et la responsabilité du système après lancement.",
    deliverables: [
      {
        title: "Note de flux et d’opportunité",
        desc: "Définition précise du problème business, des utilisateurs, des données d’entrée, des points de décision, des contraintes, des critères de succès et de la valeur attendue.",
      },
      {
        title: "Plan d’architecture et de contrôle",
        desc: "Conception du système, flux de données, limites d’outils, revue humaine, comportements de repli, escalades et contrôles de risque.",
      },
      {
        title: "Registre d’évaluation et d’acceptation",
        desc: "Cas de test, modes d’échec observés, seuils de qualité, critères d’acceptation business et notes de préparation au lancement.",
      },
      {
        title: "Dossier de transfert production",
        desc: "Documentation, attentes de monitoring, modèle de responsabilité, cadence de support et recommandations nettes après lancement.",
      },
    ],
    founderLabel: "Expérience fondateur",
    founderTitle: "Expérience de production dirigée par le fondateur.",
    founderP2:
      "Vert AI démontre sa rigueur par sa méthode, ses standards de livraison et ses schémas de production : flux cadrés, base de mesure claire, évaluation, monitoring, revue humaine, gouvernance et impact opérationnel mesurable.",
    surfacesLabel: "Prochaine surface",
    surfacesTitle: "Choisir selon la question d’achat.",
    surfaces: [
      {
        href: "/services",
        title: "Explorer les systèmes IA de production",
        desc: "Comparer les mandats en IA de production, automatisation de flux, plateformes de données, intelligence décisionnelle et préparation IA.",
      },
      {
        href: "/industries",
        title: "Explorer les industries servies",
        desc: "Relier le travail de Vert AI aux contextes détail, e-commerce, CPG, franchise, services professionnels et services B2B.",
      },
      {
        href: "/insights",
        title: "Lire l’analyse d’implémentation",
        desc: "Utiliser les guides acheteurs et notes de terrain pour évaluer les promesses IA avec plus de précision.",
      },
      {
        href: "/contact",
        title: "Planifier un appel de cadrage IA",
        desc: "Décrire le flux, le défi de données ou le système décisionnel à améliorer.",
      },
    ],
    ctaHeadline: "Amenez le vrai flux.",
    ctaDesc:
      "Un appel de cadrage devrait clarifier s’il existe un système de production qui vaut la peine d’être construit, ce qui le prouverait, qui en serait responsable et ce qui doit être vrai avant la mise en ligne.",
  },
  notFound: {
    title: "404",
    message: "Page introuvable.",
    backHome: "Retour à l’accueil",
  },
  footer: {
    tagline: "Systèmes IA, données et décision de calibre production. Conçus et déployés depuis le Canada.",
    engagements: "Mandats",
    services: "Mandats",
    industries: "Industries",
    insights: "Perspectives",
    company: "La firme",
    contactLabel: "Contact",
    copyright: "Vert AI Inc.",
    bottomTagline: "IA, Données et Systèmes décisionnels · Canada",
  },
  solutionsHub: {
    heroLabel: "Solutions",
    heroTitle: "Modèles IA de production pour flux coûteux.",
    heroSubtitle:
      "Utilisez ce catalogue pour relier documents, décisions récurrentes, automatisation de flux et besoins de plateforme données au mandat Vert AI, aux contrôles, au modèle de responsabilité et au premier build qui conviennent.",
    primaryLabel: "Catégories de solutions",
    primaryTitle: "Revoir par problème opérationnel.",
    primarySubtitle:
      "Chaque catégorie relie un problème opérationnel récurrent au schéma système, aux contrôles, aux besoins données et au mandat qui conviennent.",
    secondaryLabel: "Capacités additionnelles",
    secondaryTitle: "Domaines de soutien.",
    recommendationTitle: "Recommandation et personnalisation",
    recommendationDesc:
      "Moteurs de recommandation et logique de prochaine meilleure action pour le commerce en ligne, le merchandising et l’expérience client.",
    recommendationVia: "Via IA prédictive",
    profitabilityGrowthTitle: "Décisions de rentabilité et de croissance",
    profitabilityGrowthDesc:
      "Systèmes de mesure et de modélisation reliant canal, cohorte et délai de récupération pour l’allocation de capital.",
    profitabilityGrowthVia: "Via IA prédictive",
    aiOpsTitle: "Opérations IA et contrôle",
    aiOpsDesc:
      "Monitoring, assurance qualité, évaluation, logique d’escalade et garde-fous pour les systèmes IA en production.",
    aiOpsVia: "Transversal · Post-lancement",
    bridgeLabel: "Comment engager",
    bridgeTitle: "Du problème au mandat.",
    bridgeDesc:
      "Chaque solution est livrée à travers le chemin de service qui correspond au flux, à la fondation de données, à la couche décisionnelle ou à la question de préparation. Chaque mandat est cadré selon votre problème, tarifé selon la valeur attendue, avec livrables, responsables, contrôles et critères d’acceptation définis d’avance.",
    bridgeCta: "Explorer les systèmes IA de production",
    ctaHeadline: "Cartographier votre premier flux IA.",
    ctaDesc: "Nous cartographions le flux, le risque de production, la responsabilité, le chemin de service et le premier build à cadrer.",
  },
  solutions: {
    aiAgents: {
      label: "Solution",
      heroTitle: "Agents IA et automatisation de flux",
      hubDesc:
        "Flux IA encadrés pour les opérations, la finance et l’exécution interne. Avec routage, contrôles et révision humaine.",
      heroSubtitle:
        "Flux IA encadrés qui automatisent des processus répétitifs à forte valeur seulement lorsque le risque est contrôlé. Routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
      problemLabel: "Le problème",
      problemTitle: "Des processus manuels qui ne passent pas à l’échelle.",
      problemP1:
        "Des flux à forte valeur en opérations, finance et exécution interne sont encore exécutés à la main. Le volume monte. Les effectifs non. L’automatisation générique gère les cas simples et casse sur les exceptions, les cas limites et tout ce qui requiert du jugement.",
      problemP2:
        "Vert AI construit des agents bornes qui traitent la routine, escaladent les exceptions et gardent les humains en contrôle lorsque le jugement, le risque ou l’impact client comptent.",
      gapsLabel: "Pourquoi les outils génériques échouent",
      gaps: "Incapables de raisonnement multi-étapes ou de logique conditionnelle|Aucun chemin de repli ni d’escalade quand la confiance baisse|Aucune intégration entre plusieurs systèmes internes|Aucune piste d’audit ni contrôle opérationnel|Échouent sur les cas limites qui exigent du jugement contextuel",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Agents IA multi-étapes pour flux opérationnels|Systèmes de routage et de triage avec scoring de confiance|Pipelines d’automatisation déclenchés par documents|Automatisation de flux finance et approvisionnement|Copilotes internes pour équipes fonctionnelles|Orchestration hybride règles et LLM|Logique de gestion d’exceptions et d’escalade|Interfaces de révision humaine dans la boucle",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où çà s’applique.",
      workflows:
        "Traitement et validation de factures|Gestion de commandes et exceptions|Vérification de conformité et revue documentaire|Automatisation de l’intégration des employés|Routage et triage de demandes internes|Automatisation des communications de chaîne d’approvisionnement|Préparation d’audits et collecte de preuves",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains restent dans la boucle.",
      humanDesc:
        "Chaque système d’agent inclut des seuils d’escalade configurables, des files de révision manuelle, des journaux d’audit et des contrôles opérationnels. L’automatisation gère le volume. Les humains gèrent le jugement. Le système connaît la différence.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA agentique.",
      engagementDesc:
        "Cette solution est typiquement livrée via le mandat IA agentique, qui couvre le cadrage, l’architecture, l’implémentation, l’évaluation, les contrôles et le déploiement en production avec responsabilité claire.",
      engagementHref: "/services/agentic-ai-workflows",
      engagementCta: "Cartographier un premier flux IA",
      ctaHeadline: "Décrivez le flux.",
      ctaDesc: "On cadrera le système, l’échéancier et les livrables.",
    },
    documentIntelligence: {
      label: "Solution",
      heroTitle: "Intelligence documentaire",
      hubDesc:
        "Extraction, classification et structuration à partir de contrats, factures, appels d’offres et flux documentaires à haute friction.",
      heroSubtitle:
        "Extraction, classification, validation, files de revue et structuration de l’information à partir de contrats, propositions, factures, appels d’offres et autres flux documentaires à haute friction.",
      problemLabel: "Le problème",
      problemTitle: "Des documents qui emprisonnent la valeur.",
      problemP1:
        "L’information critique est enfermée dans des documents non structurés. Contrats, propositions, factures et dossiers réglementaires contiennent les données dont vos systèmes ont besoin, mais les extraire de façon fiable à grande échelle dépassé l’OCR générique et les outils par modèles.",
      problemP2:
        "Vert AI construit des systèmes d’intelligence documentaire qui extraient, classifient, valident, revisent et structurent l’information de documents complexes avec des contrôles de production.",
      gapsLabel: "Pourquoi les outils génériques échouent",
      gaps: "L’extraction par modèle échoue sur les variations de format|L’OCR seul ne comprend pas la sémantique|Aucune validation ni scoring de confiance|Ne cartographie pas les données vers les entités d’affaires|Aucune boucle de rétroaction pour l’amélioration continue",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Analyse de contrats et extraction de clauses|Systèmes de traitement et validation de factures|Automatisation de réponses aux appels d’offres|Classification de documents réglementaires|Traitement de réclamations d’assurance|Comparaison et scoring de propositions|Pipelines document vers base de données|Extraction multi-format avec scoring de confiance",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où çà s’applique.",
      workflows:
        "Revue de contrats d’approvisionnement|Automatisation des comptes fournisseurs|Analyse de documents juridiques|Traitement documentaire en souscription d’assurance|Classification de documents de conformité|Réception et cotation de propositions|Extraction de dépôts réglementaires",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains valident ce qui compte.",
      humanDesc:
        "Chaque système inclut des seuils de confiance, des files de révision manuelle pour les extractions à faible confiance et des règles de validation alignées sur la logique d’affaires. Le système gère le volume. Les humains gèrent les exceptions et les cas limites.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA générative.",
      engagementDesc:
        "Les solutions d’intelligence documentaire sont typiquement livrées via le mandat IA générative. Pour les organisations qui doivent aussi restructurer leur fondation de données, le mandat Plateformes de données peut s’appliquer.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Explorer les systèmes documentaires ancrés",
      ctaHeadline: "Montrez-nous les documents.",
      ctaDesc: "On cadrera le système d’extraction, les cibles de précision et le chemin de déploiement.",
    },
    knowledgeSystems: {
      label: "Solution",
      heroTitle: "Gestion du savoir et recherche d’entreprise",
      hubDesc:
        "Assistants internes qui récupèrent, raisonnent et rendent opérationnel le savoir institutionnel à travers l’organisation.",
      heroSubtitle:
        "Assistants internes qui récupèrent, raisonnent et rendent opérationnel le savoir institutionnel à travers politiques, procédures, données produit et documentation commerciale avec attribution des sources et boucles de feedback.",
      problemLabel: "Le problème",
      problemTitle: "Du savoir qui existe mais qu’on ne trouve pas.",
      problemP1:
        "Votre organisation a les réponses. Elles sont dispersées dans des centaines de documents, wikis, procédures et systèmes hérités. Les employés perdent des heures à chercher de l’information qui devrait prendre quelques secondes. La recherche générique retourne des mots-clés, pas des réponses.",
      problemP2:
        "Vert AI construit des systèmes de savoir qui récupèrent le contexte pertinent, raisonnent sur des sources approuvées, affichent les citations et rendent le feedback qualité visible.",
      gapsLabel: "Pourquoi la recherche classique échoue",
      gaps: "La recherche par mots-clés retourne des résultats, pas des réponses|Ne raisonne pas à travers plusieurs documents|Aucune compréhension du contexte organisationnel|Ne gère pas les questions de suivi ni les clarifications|Aucune attribution de source ni scoring de confiance",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Assistants de savoir d’entreprise avec architecture RAG|Systèmes de recherche de politiques et procédures|Recherche d’information produit pour ventes et support|Assistants de documentation technique|Agrégation de savoir multi-source|Interfaces conversationnelles avec attribution de source|Recherche contextuelle avec compréhension sémantique|Outils de curation et de maintenance de base de connaissances",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où çà s’applique.",
      workflows:
        "Questions sur les politiques RH et avantages|Recherche de savoir en support technique|Habilitation des ventes et information produit|Accès au savoir de conformité réglementaire|Livraison de savoir d’intégration et de formation|Consultation de procédures opérationnelles|Partage de savoir interservices",
      humanLabel: "Supervision humaine",
      humanTitle: "Une précision que vous pouvez vérifier.",
      humanDesc:
        "Chaque système de savoir inclut l’attribution de source, des indicateurs de confiance et des mécanismes de rétroaction. Les utilisateurs peuvent vérifier d’où viennent les réponses. Les administrateurs suivent la précision, identifient les lacunes et améliorent le système en continu.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA générative.",
      engagementDesc:
        "Les systèmes de savoir sont livrés via le mandat IA générative. La construction couvre la conception de l’architecture de recherche, le pipeline d’ingestion, la logique de raisonnement et le déploiement en production avec monitoring.",
      engagementHref: "/services/production-ai-systems",
      engagementCta: "Explorer les systèmes de savoir gouvernés",
      ctaHeadline: "Décrivez le problème de savoir.",
      ctaDesc: "On cadrera le système de recherche, les sources et le chemin de déploiement.",
    },
    customerSupport: {
      label: "Solution",
      heroTitle: "Service client et systèmes de soutien",
      hubDesc:
        "Systèmes IA qui résolvent les demandes, assistent les agents, classifient l’intention et accélèrent le service sans sacrifier la qualité.",
      heroSubtitle:
        "Systèmes IA qui résolvent les demandes répétitives, assistent les agents, classifient l’intention, remontent le bon savoir et accélèrent le service sans sacrifier la qualité, la confidentialité ni la supervision.",
      problemLabel: "Le problème",
      problemTitle: "Un service qui ne passé pas à l’échelle.",
      problemP1:
        "Le volume de requêtes monte. La capacité des agents, non. Les questions répétitives consomment vos agents expérimentés. Les délais dérivent. La qualité devient incohérente. Les robots conversationnels génériques ne traitent que les cas les plus simples et frustrent les clients dès qu’on dépassé la FAQ.",
      problemP2:
        "Vert AI construit des systèmes de soutien qui traitent la routine avec précision, assistent les agents sur les cas complexes et escaladent quand le jugement humain ou l’impact client exige une revue.",
      gapsLabel: "Pourquoi les robots conversationnels génériques échouent",
      gaps: "Ne traitent que les questions de type FAQ|Aucune intégration au savoir ou aux systèmes internes|Ne peuvent pas assister les agents sur les cas complexes|Aucune classification d’intention ni logique de routage|Aucun apprentissage à partir des patterns de résolution",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Triage et routage de requêtes par IA|Résolution automatisée des types de demandes courants|Assistance aux agents avec réponses suggérées|Classification d’intention et scoring de priorité|Génération de réponses ancrées dans le savoir|Logique d’escalade fondée sur la confiance|Détection de sentiment et d’urgence|Monitoring de qualité et boucles de rétroaction",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où çà s’applique.",
      workflows:
        "Automatisation du soutien de niveau 1|Demandes de statut et de suivi de commande|Traitement des retours et échanges|Questions de compte et de facturation|Demandes d’information produit|Planification et coordination de services|Classification et routage de plaintes",
      humanLabel: "Supervision humaine",
      humanTitle: "Les agents gardent le contrôle.",
      humanDesc:
        "Chaque système de soutien inclut des limites d’automatisation configurables, le remplacement par l’agent et des seuils d’escalade. L’IA gère le volume et la cohérence. Les agents gèrent la complexité et l’empathie. Le système route intelligemment entre les deux.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA agentique.",
      engagementDesc:
        "Les systèmes de service client sont livrés via le mandat IA agentique. Le périmètre inclut la modélisation d’intention, l’intégration du savoir, les interfaces d’assistance aux agents et le déploiement en production avec monitoring de qualité.",
      engagementHref: "/services/agentic-ai-workflows",
      engagementCta: "Cartographier un premier flux IA",
      ctaHeadline: "Décrivez le défi de soutien.",
      ctaDesc: "On cadrera le système, les limites d’automatisation et le chemin de déploiement.",
    },
    predictiveModels: {
      label: "Solution",
      heroTitle: "Modèles prédictifs et science décisionnelle",
      hubDesc:
        "Modèles sur mesure pour l’attrition, la valeur client, le scoring et la prévision. Conçus pour scorer, classer et guider l’action en production.",
      heroSubtitle:
        "Modèles sur mesure pour l’attrition, la valeur client, le scoring de prospects, la prévision de demande, la priorisation et l’aide à la décision commerciale. Conçus pour scorer, classer, expliquer et guider l’action en production.",
      problemLabel: "Le problème",
      problemTitle: "Des décisions guidées par l’instinct, pas par le signal.",
      problemP1:
        "La plupart des entreprises ont des tableaux de bord qui décrivent le passé. Très peu ont des systèmes qui prédisent ce qui s’en vient et recommandent quoi faire. Les modèles existants vivent dans des notebooks. Ils n’atteignent jamais les flux où les décisions se prennent.",
      problemP2:
        "Vert AI construit des modèles prédictifs qui débouchent sur une décision commerciale via des systèmes déployés de scoring, recommandation, revue et feedback.",
      gapsLabel: "Pourquoi les tableaux de bord échouent",
      gaps: "L’analyse descriptive ne prédit pas les résultats|Les modèles dans les notebooks n’atteignent pas la production|Aucune intégration aux flux opérationnels|Le scoring exige un déploiement temps réel ou quasi temps réel|Aucune boucle de rétroaction entre prédiction et résultat",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Modèles de prédiction et d’intervention d’attrition|Modélisation de la valeur client|Systèmes de scoring et de priorisation de prospects|Prévision de demande et d’inventaire|Support d’optimisation d’assortiment et de prix|Modèles de propension pour marketing et ventes|Scoring de qualité et segmentation client|Classification et priorisation opérationnelle",
      workflowsLabel: "Décisions typiques",
      workflowsTitle: "Décisions qu’on améliore.",
      workflows:
        "Quels clients risquent le plus de partir|Où allouer l’effort commercial|Quels niveaux d’inventaire maintenir|Quels prospects prioriser|Comment segmenter les clients par valeur|Où ajuster les prix|Dans quelles cohortes marketing investir",
      humanLabel: "Aide à la décision, pas remplacement",
      humanTitle: "Les modèles informent. Les humains décident.",
      humanDesc:
        "Chaque modèle est construit avec interprétabilité, scoring de confiance, monitoring et cadre d’action clair. Le système fournit le signal. Votre équipe applique le jugement. Les seuils de décision sont configurables et transparents.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA prédictive.",
      engagementDesc:
        "Les solutions de modèles prédictifs et de science décisionnelle sont livrées via le mandat IA prédictive, qui couvre le cadrage de la décision, la conception du modèle, l’entraînement, l’évaluation, le déploiement et l’interprétation d’affaires.",
      engagementHref: "/services/decision-intelligence",
      engagementCta: "Voir comment fonctionne l’intelligence décisionnelle",
      ctaHeadline: "Nommez la décision.",
      ctaDesc: "On cadrera le modèle, les exigences de données et le chemin de déploiement.",
    },
    dataPlatforms: {
      label: "Solution",
      heroTitle: "Plateformes de données pour l’IA",
      hubDesc:
        "Couches source de vérité, sémantiques et d’assurance qualité requises pour une IA fiable et des analyses cohérentes en production.",
      heroSubtitle:
        "Les couches source de vérité, sémantiques, contrôle d’accès et assurance qualité requises pour une IA fiable, des analyses cohérentes et un déploiement de modèles en production. Conçues pour la confiance et la traçabilité.",
      problemLabel: "Le problème",
      problemTitle: "L’IA ne peut pas opérer sur des données peu fiables.",
      problemP1:
        "Les investissements en IA et en analyses s’effondrent quand les données sous-jacentes sont fragmentées, incohérentes ou peu fiables. Les modèles entraînés sur des entrées peu fiables produisent des décisions peu fiables. Les rapports bâtis sur une logique incohérente érodent la confiance plus vite qu’ils ne la construisent.",
      problemP2:
        "Vert AI construit la fondation de données dont vos systèmes IA et décisionnels ont besoin avant de pouvoir opérer de façon fiable.",
      gapsLabel: "Pourquoi les architectures de données existantes échouent",
      gaps: "Des sources fragmentées, sans référentiel unique|Définitions de métriques incohérentes entre les équipes|Aucune couche sémantique pour les entrées de modèles IA|Contrôles de qualité et de confiance manquants|Fragilité des pipelines et manque de traçabilité",
      buildsLabel: "Ce qu’on construit",
      buildsTitle: "Systèmes qu’on livre dans cette catégorie.",
      builds:
        "Architecture de données source de vérité|Couche sémantique et définitions de métriques|Contrôles de qualité et de confiance|Instrumentation événementielle et traçabilité|Couches de préparation IA et ML|Résolution d’entités et gestion d’identité|Ingénierie de fiabilité des pipelines|Cadres de documentation et de gouvernance",
      workflowsLabel: "Défis de données courants",
      workflowsTitle: "Problèmes qu’on résout.",
      workflows:
        "Les rapports donnent des réponses différentes selon qui les produit|Modèles IA entraînés sur des entrées incohérentes|Aucune source de vérité unique entre les systèmes|Instrumentation manquante pour les événements d’affaires clés|Problèmes de qualité de données qui bloquent le déploiement IA|Les équipes ne s’entendent pas sur les définitions de métriques|Échecs de pipeline sans traçabilité",
      humanLabel: "Conçu pour la confiance",
      humanTitle: "Des données sur lesquelles votre équipe peut compter.",
      humanDesc:
        "Chaque plateforme de données inclut documentation, règles de gouvernance, logique d’accès, monitoring de qualité et cartographie claire des responsabilités. L’objectif n’est pas seulement des données propres. C’est des données fiables sur lesquelles votre organisation et votre pile IA peuvent s’appuyer.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via Plateformes de données.",
      engagementDesc:
        "Les solutions de plateforme de données sont livrées via le mandat Plateformes de données, qui couvre la cartographie des sources, la modélisation des données, les contrôles de qualité, l’instrumentation, la préparation IA et la documentation.",
      engagementHref: "/services/data-platforms",
      engagementCta: "Explorer les fondations de données pour l’IA",
      ctaHeadline: "Commencez par les données.",
      ctaDesc: "On cadrera l’architecture et le chemin vers la fiabilité.",
    },
  },
  authority: {
    vetVendor: {
      label: "Guide stratégique",
      heroTitle: "Comment évaluer un fournisseur IA",
      heroSubtitle:
        "Un cadre décisionnel pour les opérateurs qui évaluent des partenaires d’implémentation IA. Quoi chercher, quoi éviter et comment distinguer la vraie capacité d’un marketing soigné.",
      readTime: "12 min de lecture · Référence permanente",
      thesisLabel: "Le vrai problème",
      thesisTitle: "La plupart des évaluations de fournisseurs IA passent à côté de l’essentiel.",
      thesisP1:
        "Les entreprises qui évaluent des fournisseurs IA se concentrent sur les références, les études de cas et les prix. C’est utile mais insuffisant. Les variables qui déterminent le succès ou l’échec d’un projet IA portent presque entièrement sur la capacité d’ingénierie, l’évaluation de la maturité des données, la préparation à la production et le support post-déploiement.",
      thesisP2:
        "Ce guide fournit un cadre pratique pour distinguer les fournisseurs capables de livrer des systèmes en production de ceux qui livrent des présentations.",
      sectionsLabel: "Cadre d’évaluation",
      sectionsTitle: "Quoi évaluer.",
      sections:
        "Historique de production|Profondeur technique contre étendue|Capacité d’évaluation des données|Modèle de déploiement et de transfert|Transparence des prix et du périmètre|Structure de support post-lancement",
      sectionDescs:
        "Demandez des systèmes qui roulent en production aujourd’hui. Les démos et preuves de concept ne sont pas des preuves de capacité de livraison.|Les spécialistes qui approfondissent moins de problèmes sont plus faciles à évaluer que les généralistes qui prétendent tout faire. Posez des questions sur les décisions d’architecture, pas seulement sur les résultats.|Un fournisseur solide évalué la maturité de vos données avant de s’engager sur un échéancier. Les fournisseurs faibles sautent cette étape et blâment les données plus tard.|Comment le système se rend-il en production? Qui le maintient? Si la réponse est floue, le projet bloquera au déploiement.|Un périmètre fixe avec livrables définis est plus facile à gouverner qu’un forfait ouvert. Demandez des critères d’acceptation écrits.|Les systèmes IA exigent monitoring, réentraînement et raffinement. Demandez ce qui se passe après le lancement.",
      takeawaysLabel: "Signaux clés",
      takeawaysTitle: "Ce qui distingue les bons fournisseurs des mauvais.",
      takeaways:
        "Ils cadrent avant de vendre|Ils évaluent la maturité des données avant de s’engager sur un échéancier|Ils construisent pour la production, pas pour les démos|Ils définissent les sorties et critères d’acceptation, pas seulement l’effort|Ils expliquent les compromis honnêtement|Ils ont un modèle post-lancement clair|Ils ne sous-traitent pas l’ingénierie cœur",
      perspectiveLabel: "La perspective Vert AI",
      perspectiveTitle: "On à bâti Vert AI pour passer ce test.",
      perspectiveDesc:
        "Chaque mandat à des livrables définis, des critères d’acceptation et un point de contact unique du cadrage à la production. Aucun sous-traitant. Aucun transfert. Aucune ambiguïté sur ce qui sera livré.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions: "Ce que veut vraiment dire l’IA de production|Mandat IA agentique|Toutes les solutions",
      relatedHrefs: "/insights/production-grade-ai|/services/agentic-ai-workflows|/solutions",
      ctaHeadline: "Vous évaluez des partenaires IA?",
      ctaDesc:
        "Discutons de vos exigences. On vous donnera une évaluation honnête d’adéquation et de ce à quoi ressemble un mandat prêt pour la production.",
    },
    productionGrade: {
      label: "Référence technique",
      heroTitle: "Ce que veut vraiment dire « IA de calibre production »",
      heroSubtitle:
        "Une définition technique pour les opérateurs et décideurs. Ce qui sépare une démo fonctionnelle d’un système qui roule de façon fiable à l’intérieur d’une entreprise.",
      readTime: "10 min de lecture · Référence permanente",
      thesisLabel: "L’écart de définition",
      thesisTitle: "Tout le monde dit « calibre production ». Peu le livrent.",
      thesisP1:
        "Le terme « calibre production » a été vidé de son sens à force d’usage. Les fournisseurs s’en servent pour décrire n’importe quoi, du notebook Jupyter avec une interface Streamlit jusqu’à un système entièrement monitoré, tolérant aux pannes et accompagné de documentation opérationnelle. Pour les acheteurs, cette ambiguïté coûte cher.",
      thesisP2:
        "Cette page définit ce que le calibre production exige réellement, pourquoi la plupart des projets IA n’y arrivent pas et quoi chercher chez un partenaire capable de le livrer.",
      sectionsLabel: "Exigences de production",
      sectionsTitle: "Ce que le calibre production exige.",
      sections:
        "Fiabilité et tolérance aux pannes|Monitoring et observabilité|Intégrité des pipelines de données|Sécurité et contrôles d’accès|Documentation et transfert|Modèle de support opérationnel",
      sectionDescs:
        "Le système gère les erreurs gracieusement, réessaie intelligemment et se dégrade sans défaillance catastrophique. Il roule sur déclencheurs ou planificateurs, pas par exécution manuelle.|Métriques de performance, scores de qualité, détection de dérive et alertes. Vous savez quand le système se dégrade avant vos utilisateurs.|Les données d’entrée sont validées, versionnées et traçables. Le système sait quand ses entrées changent d’une façon qui affecte la qualité de sortie.|Accès par rôle, pistes d’audit et architecture conforme. Pas des ajouts de dernière minute juste avant le lancement.|Documentation technique complète, procédures opérationnelles et habilitation de l’équipe. Le système est transférable, pas dépendant de celui qui l’a construit.|Monitoring, réentraînement, raffinement et support de feuille de route. La production est le début du cycle de vie du système, pas la fin.",
      takeawaysLabel: "Liste de vérification diagnostique",
      takeawaysTitle: "Votre système IA est-il de calibre production?",
      takeaways:
        "Il roule sans intervention manuelle|Il gère les erreurs et les cas limites gracieusement|Il est monitoré avec des alertes claires|Ses données d’entrée sont validées et traçables|Il à une documentation complète|Il à une propriété opérationnelle définie|Il à un plan de réentraînement et de raffinement|Il respecte les exigences de sécurité et de conformité",
      perspectiveLabel: "Le standard Vert AI",
      perspectiveTitle: "C’est la barre contre laquelle Vert AI cadre les mandats.",
      perspectiveDesc:
        "Chaque mandat est cadré selon des standards de préparation à la production : chemin de déploiement, monitoring, documentation, transfert opérationnel et critères d’acceptation avant lancement.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions: "Mandat IA agentique|Agents IA et automatisation de flux|Plateformes de données pour l’IA",
      relatedHrefs: "/services/agentic-ai-workflows|/solutions/ai-agents-workflow-automation|/solutions/data-platforms-for-ai",
      ctaHeadline: "Besoin d’un système de calibre production?",
      ctaDesc:
        "Décrivez le flux. On cadrera le système, le chemin de déploiement et les exigences de production.",
    },
    workflowsDeserveAI: {
      label: "Cadre décisionnel",
      heroTitle: "Quels flux méritent l’IA — et lesquels non",
      heroSubtitle:
        "Tous les processus n’ont pas besoin d’IA. Un cadre pratique pour identifier où l’IA crée une vraie valeur et où elle crée une complexité coûteuse.",
      readTime: "9 min de lecture · Référence permanente",
      thesisLabel: "Le problème de sélection",
      thesisTitle: "La plupart des entreprises automatisent les mauvais flux en premier.",
      thesisP1:
        "La pression d’adopter l’IA pousse les entreprises à l’appliquer partout sans évaluer où elle crée vraiment de la valeur. Le résultat : un portefeuille de pilotes coûteux qui résolvent des problèmes que personne n’a priorisés et qui ignorent les flux qui généreraient le meilleur rendement.",
      thesisP2:
        "Ce cadre aide les opérateurs à identifier quels flux méritent un investissement IA, lesquels méritent une automatisation plus simple et lesquels devraient rester manuels.",
      sectionsLabel: "Critères d’évaluation",
      sectionsTitle: "Comment évaluer l’adéquation flux-IA.",
      sections:
        "Volume et répétition|Complexité décisionnelle|Disponibilité des données|Coût et tolérance aux erreurs|Exigences d’intégration|Clarté de la mesure",
      sectionDescs:
        "Les flux à fort volume et répétitifs avec schémas constants sont les meilleurs candidats. Les flux à faible volume et hautement variables justifient rarement l’investissement IA.|Les flux qui exigent du raisonnement multi-étapes, du jugement contextuel ou de la reconnaissance de motifs bénéficient de l’IA. Les flux à règles simples sont mieux servis par l’automatisation traditionnelle.|L’IA exige des données structurées, accessibles et suffisamment riches. Si les données n’existent pas ou exigent un nettoyage massif, commencez par la plateforme de données.|Les flux où les erreurs sont coûteuses mais détectables sont de bons candidats. Les flux où les erreurs sont catastrophiques et indétectables exigent une prudence extrême.|Les flux qui opèrent en isolation sont plus faciles à automatiser. Les flux profondément intégrés à des systèmes complexes exigent plus de planification architecturale.|Si vous ne pouvez pas mesurer l’amélioration, vous ne pouvez pas justifier l’investissement. Métriques de référence claires et critères de succès sont des prérequis.",
      takeawaysLabel: "Signaux de décision",
      takeawaysTitle: "Quand investir dans l’IA.",
      takeaways:
        "Le flux est à fort volume et répétitif|Les données existent et sont raisonnablement structurées|Le coût des erreurs est gérable avec supervision humaine|L’amélioration est mesurable en termes d’affaires|Le flux a des limites et des points de transfert clairs|Le logiciel standard ne peut pas gérer la complexité|L’équipe est prête à adopter et à opérer le système",
      perspectiveLabel: "L’approche Vert AI",
      perspectiveTitle: "On commence par le flux, pas par la technologie.",
      perspectiveDesc:
        "Chaque mandat commence par la sélection du flux et le cadrage d’affaires. On aide les clients à identifier les meilleures ciblés d’automatisation avant de s’engager dans une construction. Si l’IA n’est pas la bonne réponse, on le dit.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions:
        "Agents IA et automatisation de flux|Intelligence documentaire|Service client et systèmes de soutien|Toutes les solutions",
      relatedHrefs:
        "/solutions/ai-agents-workflow-automation|/solutions/document-intelligence|/solutions/customer-support-service-systems|/solutions",
      ctaHeadline: "Pas certain où l’IA s’applique?",
      ctaDesc:
        "Décrivez vos flux. On vous aidera à identifier où l’IA crée une vraie valeur et où elle n’en crée pas.",
    },
  },
  industriesHub: {
    heroLabel: "Industries",
    heroTitle: "Systèmes IA de production pour équipes opérationnelles.",
    heroSubtitle:
      "Voyez où l’IA peut améliorer le débit, la qualité décisionnelle, la constance de service et la fiabilité des données dans les flux coûteux, les exceptions et les décisions récurrentes sans perdre revue, responsabilité ou contrôle.",
    listLabel: "Secteurs servis",
    listTitle: "Modèles de flux propres à chaque industrie.",
    listSubtitle:
      "On construit des systèmes IA et données pour les industries où le logiciel standard s’arrête, où la qualité des données compte et où une implantation ratée coûte cher.",
    bridgeLabel: "Capacités transversales",
    bridgeTitle: "Même rigueur. Contexte différent.",
    bridgeDesc:
      "Chaque mandat industriel s’appuie sur les mêmes solutions et le même modèle de livraison. L’architecture, les patterns de données, les chemins de revue et les exigences opérationnelles changent. Le standard d’ingénierie, lui, ne change pas.",
    ctaHeadline: "Revoir le premier flux qui mérite un cadrage.",
    ctaDesc:
      "On cadrera le système autour de vos flux, contraintes, environnement de données et risque de production.",
  },
  industries: {
    accounting: {
      label: "Industrie",
      heroTitle: "Systèmes IA pour cabinets comptables",
      hubDesc:
        "Traitement documentaire, recherche de savoir et automatisation de flux conçus pour les exigences de conformité, de précision et de piste d’audit des cabinets comptables.",
      heroSubtitle:
        "Systèmes IA de calibre production pour le traitement documentaire, la recherche de savoir, la communication client et l’automatisation de flux. Conçus avec chemins de revue pour les exigences de conformité, de précision et de piste d’audit de la comptabilité professionnelle.",
      painsLabel: "Le défi",
      painsTitle: "Là où le logiciel standard s’arrête.",
      painsP1:
        "Les cabinets comptables traitent d’énormes volumes de documents structurés et non structurés, des demandes clients répétitives et des exigences de conformité complexes. Les logiciels de gestion de cabinet gèrent la planification et la facturation mais ne peuvent pas automatiser le travail intensif en savoir qui consomme le temps des associés.",
      painsP2:
        "Les systèmes IA pour les flux comptables doivent respecter des exigences de précision, de conformité et de piste d’audit que l’automatisation générique ne peut pas satisfaire.",
      painsListLabel: "Points de friction courants",
      pains:
        "Traitement manuel de documents pour déclarations fiscales et états financiers|Demandes clients répétitives qui consomment le temps des associés|Savoir emprisonné dans l’expertise des associés et la mémoire institutionnelle|Vérifications de conformité qui reposent sur le savoir individuel|Qualité de travail incohérente entre les membres de l’équipe|Contraintes de capacité saisonnière sans solution évolutive",
      systemsLabel: "Ce qu’on construit",
      systemsTitle: "Systèmes pour les flux comptables.",
      systems:
        "Extraction de données de formulaires fiscaux et d’états financiers|Automatisation des demandes clients avec réponses conformes|Systèmes de recherche pour le code fiscal et la réglementation|Automatisation de lettres de mission et de propositions|Systèmes de revue et d’assurance qualité des papiers de travail|Assistants de savoir interne pour la formation et la consultation",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions:
        "Intelligence documentaire|Gestion du savoir et recherche d’entreprise|Agents IA et automatisation de flux|Service client et systèmes de soutien",
      solutionHrefs:
        "/solutions/document-intelligence|/solutions/knowledge-systems-enterprise-retrieval|/solutions/ai-agents-workflow-automation|/solutions/customer-support-service-systems",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les cabinets comptables.",
      engagementDesc:
        "La plupart des mandats pour cabinets comptables sont livrés via IA agentique pour l’automatisation de flux, IA générative pour l’intelligence documentaire, ou Plateformes de données quand la fondation de données doit être restructurée d’abord.",
      engagements: "IA agentique|Plateformes de données",
      engagementHrefs: "/services/agentic-ai-workflows|/services/data-platforms",
      ctaHeadline: "Décrivez le flux.",
      ctaDesc:
        "On cadrera le système autour des exigences spécifiques de votre cabinet, de ses contraintes de conformité et de ses défis de capacité.",
    },
    manufacturing: {
      label: "Industrie",
      heroTitle: "IA pour manufacturiers et distributeurs",
      hubDesc:
        "Prévision de demande, automatisation de chaîne d’approvisionnement et intelligence opérationnelle conçues pour les flux manufacturiers et de distribution.",
      heroSubtitle:
        "Systèmes IA de calibre production pour la prévision de demande, l’optimisation d’inventaire, la communication fournisseur et la prise de décision opérationnelle. Conçus pour la revue des planificateurs, la qualité des données et la complexité du manufacturier et de la distribution.",
      painsLabel: "Le défi",
      painsTitle: "Là où les ERP et outils de planification s’arrêtent.",
      painsP1:
        "Les manufacturiers et distributeurs opèrent avec des chaînes d’approvisionnement complexes, des courbes de demande volatils et des marges étroites. Les ERP gèrent les transactions mais ne peuvent ni prédire les changements de demande, ni optimiser l’allocation d’inventaire, ni automatiser les communications qui relient fournisseurs, entrepôts et clients.",
      painsP2:
        "Les systèmes IA pour le manufacturier doivent s’intégrer aux ERP et WMS existants, traiter des données opérationnelles imparfaites et livrer des recommandations sur lesquelles les contremaîtrès et planificateurs peuvent agir.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Prévision de demande qui repose sur des tableurs et de l’intuition|Décisions d’allocation d’inventaire qui ignorent les signaux temps réel|Communication fournisseur et gestion de commandes manuelles|Contrôle qualité qui détecte les problèmes après la production|Données déconnectées entre ERP, WMS et outils de planification|Aucun support décisionnel pour le prix, l’assortiment ou le timing d’approvisionnement",
      systemsLabel: "Ce qu’on construit",
      systemsTitle: "Systèmes pour le manufacturier et la distribution.",
      systems:
        "Modèles de prévision de demande et d’optimisation d’inventaire|Automatisation de communication fournisseur et de commandes|Prédiction de qualité et classification de défauts|Support d’optimisation de planification de production|Intelligence de timing d’approvisionnement et de prix|Tableaux de bord opérationnels avec données de calibre décisionnel",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions: "Modèles prédictifs et science décisionnelle|Agents IA et automatisation de flux|Plateformes de données pour l’IA",
      solutionHrefs:
        "/solutions/predictive-models-decision-science|/solutions/ai-agents-workflow-automation|/solutions/data-platforms-for-ai",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les manufacturiers.",
      engagementDesc:
        "Les mandats manufacturiers impliquent typiquement IA prédictive pour la prévision et l’optimisation, IA agentique pour l’automatisation de flux, et Plateformes de données quand la fondation de données doit être travaillée d’abord.",
      engagements: "IA prédictive|IA agentique|Plateformes de données",
      engagementHrefs: "/services/decision-intelligence|/services/agentic-ai-workflows|/services/data-platforms",
      ctaHeadline: "Décrivez l’opération.",
      ctaDesc:
        "On cadrera le système autour de votre chaîne d’approvisionnement, de votre flux de production ou de votre défi de données.",
    },
    services: {
      label: "Industrie",
      heroTitle: "IA pour entreprises de services et métiers",
      hubDesc:
        "Automatisation de flux, intelligence de planification et systèmes de communication client conçus pour les opérations de services à fort volume.",
      heroSubtitle:
        "Systèmes IA de calibre production pour la prise en charge client, l’optimisation de planification, la communication de service et l’automatisation opérationnelle. Conçus avec revue humaine lorsque le jugement, le risque de répartition ou l’impact client comptent.",
      painsLabel: "Le défi",
      painsTitle: "Là où le logiciel de gestion de services s’arrête.",
      painsP1:
        "Les entreprises de services et les métiers traitent de forts volumes de demandes clients, de la complexité de planification et beaucoup de communication. Les CRM et outils de service terrain gèrent les contacts et les rendez-vous mais ne peuvent pas automatiser les flux de prise en charge, de triage et de communication qui consomment le temps des répartiteurs et coordonnateurs.",
      painsP2:
        "Les systèmes IA pour les entreprises de services doivent être rapides, fiables et assez simples pour que les équipes terrain les utilisent sans formation.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Prise en charge et triage qui dépendent d’appels et de courriels|Planification qui ne peut pas optimiser route, compétence et priorité|Communication client répétitive qui consomme le personnel de bureau|Aucun suivi systématique ni monitoring de qualité de service|Savoir emprisonné chez les techniciens et répartiteurs seniors|Soumissions et estimations qui reposent sur l’expérience individuelle",
      systemsLabel: "Ce qu’on construit",
      systemsTitle: "Systèmes pour les opérations de services.",
      systems:
        "Automatisation de la prise en charge client avec triage intelligent|Optimisation de planification avec route et compétences|Communication de service automatisée et suivi|Recherche de savoir pour techniciens terrain|Systèmes de support à la soumission et à l’estimation|Monitoring de qualité de service et boucles de rétroaction",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions:
        "Agents IA et automatisation de flux|Service client et systèmes de soutien|Gestion du savoir et recherche d’entreprise",
      solutionHrefs:
        "/solutions/ai-agents-workflow-automation|/solutions/customer-support-service-systems|/solutions/knowledge-systems-enterprise-retrieval",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les entreprises de services.",
      engagementDesc:
        "Les mandats pour entreprises de services sont typiquement livrés via IA agentique pour l’automatisation de flux et IA générative pour le savoir de communication client.",
      engagements: "IA agentique",
      engagementHrefs: "/services/agentic-ai-workflows",
      ctaHeadline: "Décrivez le flux de service.",
      ctaDesc:
        "On cadrera le système autour de votre défi de prise en charge, de planification ou de communication.",
    },
    ecommerce: {
      label: "Industrie",
      heroTitle: "IA pour les opérations de commerce en ligne",
      hubDesc:
        "Intelligence client, optimisation de catalogue et mesure de rentabilité conçues pour le commerce DTC et le détail à l’échelle.",
      heroSubtitle:
        "Systèmes IA de calibre production pour l’intelligence client, l’optimisation de catalogue, l’automatisation du soutien et la mesure de rentabilité. Conçus avec revue, monitoring et discipline de marge pour les opérations de commerce en ligne.",
      painsLabel: "Le défi",
      painsTitle: "Là où les plateformes de commerce s’arrêtent.",
      painsP1:
        "Les opérations de commerce en ligne génèrent d’énormes volumes de données entre comportement client, catalogues, canaux marketing et exécution. Les outils de plateforme gèrent les transactions et les analyses de base mais ne peuvent pas bâtir l’intelligence client, les modèles prédictifs et les systèmes décisionnels qui alimentent une croissance rentable à l’échelle.",
      painsP2:
        "Les systèmes IA pour le commerce en ligne doivent s’intégrer aux plateformes existantes, traiter des données temps réel et livrer des recommandations sur lesquelles les équipes merchandising et marketing peuvent agir immédiatement.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Coûts d’acquisition en hausse sans visibilité sur la qualité par canal|Décisions merchandising fondées sur le revenu, pas la marge de contribution|Volume de soutien qui croît plus vite que la capacité d’équipe|Aucun modèle prédictif pour l’attrition, la valeur client ou la demande|Optimisation de catalogue qui repose sur la curation manuelle|Attribution et mesure qui se contredisent entre plateformes",
      systemsLabel: "Ce qu’on construit",
      systemsTitle: "Systèmes pour les opérations de commerce en ligne.",
      systems:
        "Modèles de valeur client et de prédiction d’attrition|Mesure de rentabilité par canal, cohorte et produit|Automatisation du soutien avec intégration du savoir produit|Moteurs de recommandation et de personnalisation|Prévision de demande et optimisation d’inventaire|Enrichissement de catalogue et optimisation de recherche",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions: "Modèles prédictifs et science décisionnelle|Service client et systèmes de soutien|Plateformes de données pour l’IA",
      solutionHrefs:
        "/solutions/predictive-models-decision-science|/solutions/customer-support-service-systems|/solutions/data-platforms-for-ai",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour le commerce en ligne.",
      engagementDesc:
        "Les mandats commerce en ligne couvrent typiquement plusieurs piliers : IA prédictive pour la prévision, la recommandation et la mesure de rentabilité ; IA agentique pour le soutien et l’automatisation de catalogue ; et Plateformes de données quand la fondation de données doit être travaillée.",
      engagements: "IA prédictive|Plateformes de données|IA agentique",
      engagementHrefs: "/services/decision-intelligence|/services/data-platforms|/services/agentic-ai-workflows",
      ctaHeadline: "Décrivez le défi commerce.",
      ctaDesc:
        "On cadrera le système autour de votre problème de croissance, de mesure ou d’opérations.",
    },
  },
  seo: {
    home: {
      title: "Systèmes IA de production pour flux opérationnels | Vert AI",
      description: "Systèmes IA, plateformes de données, automatisations et moteurs de décision construits autour de flux réels, contrôles et valeur mesurable.",
      keywords: "systèmes IA production, construction systèmes IA, plateformes de données IA, systèmes décisionnels, science décisionnelle, conseil IA Canada, automatisation processus IA, agents IA pour entreprise",
    },
    services: {
      title: "Mandats IA de production, données et décision | Vert AI",
      description: "Comparer systèmes IA de production, automatisation de flux, plateformes de données, intelligence décisionnelle et préparation IA.",
      keywords: "mandats IA, systèmes IA production, automatisation agentique, plateformes données IA, intelligence décisionnelle, diagnostic IA",
    },
    agenticAI: {
      title: "IA agentique — Automatisation de processus | Vert AI",
      description: "Agents IA bornés avec routage, contrôles, plans de repli et supervision humaine. Automatisez les processus à fort volume en production.",
      keywords: "IA agentique, agents IA, automatisation processus, agents autonomes, supervision humaine",
    },
    generativeAI: {
      title: "IA générative et systèmes de récupération | Vert AI",
      description: "IA générative ancrée dans la récupération avec attribution des sources, évaluation et seuils de précision. Transformez vos connaissances en réponses fiables.",
      keywords: "IA générative, RAG, récupération augmentée, IA entreprise, systèmes de connaissance",
    },
    predictiveAI: {
      title: "IA prédictive — Modèles ML en production | Vert AI",
      description: "Modèles ML en production pour attrition, valeur à vie, demande, recommandation et rentabilité. Déployés dans vos processus décisionnels.",
      keywords: "IA prédictive, apprentissage machine, prédiction attrition, prévision demande, recommandation",
    },
    dataPlatforms: {
      title: "Plateformes de données pour l’IA | Vert AI",
      description: "Architecture de référence, couche sémantique, contrôles qualité et instrumentation prête pour l’IA. La fondation dont dépend l’IA en production.",
      keywords: "plateformes de données, architecture données, couche sémantique, données IA, ingénierie données Canada",
    },
    solutions: {
      title: "Solutions IA — Systèmes de production par domaine | Vert AI",
      description: "Agents IA, intelligence documentaire, connaissance, soutien client, modèles prédictifs et plateformes de données — construits par une seule équipe.",
      keywords: "solutions IA, cas d’usage IA, intelligence documentaire, systèmes connaissance, modèles prédictifs",
    },
    aiAgents: {
      title: "Agents IA et automatisation de processus | Vert AI",
      description: "Réduisez les coûts de traitement manuel avec des agents IA bornés. Logique de routage, contrôles, plans de repli et revue humaine aux points critiques.",
      keywords: "agents IA, automatisation processus, automatisation intelligente",
    },
    documentIntelligence: {
      title: "Intelligence documentaire et extraction | Vert AI",
      description: "IA documentaire de calibre production pour contrats, factures, formulaires et PDF non structurés. Extraction, classification et validation avec pistes d’audit.",
      keywords: "intelligence documentaire, IA documentaire, OCR, traitement documentaire intelligent",
    },
    knowledgeSystems: {
      title: "Systèmes de connaissance et récupération | Vert AI",
      description: "Assistants augmentés par récupération qui raisonnent sur vos politiques, procédures, données produit et documentation commerciale, avec attribution des sources.",
      keywords: "systèmes connaissance, recherche entreprise, RAG, IA connaissance interne",
    },
    customerSupport: {
      title: "IA pour le service à la clientèle | Vert AI",
      description: "Augmentez la vitesse de résolution et contenez le coût par requête. Classification d’intention, réponses ancrées, assistance agent et escalade par confiance.",
      keywords: "IA service client, automatisation service, assistance agent, déviation requêtes",
    },
    predictiveModels: {
      title: "Modèles prédictifs et science décisionnelle | Vert AI",
      description: "Modèles de production pour attrition, valeur à vie, demande, recommandation et rentabilité — câblés dans vos processus décisionnels.",
      keywords: "modèles prédictifs, science décisionnelle, modèles ML, prévision demande",
    },
    dataPlatformsForAI: {
      title: "Plateformes de données pour l’IA en production | Vert AI",
      description: "Architecture de référence, couche sémantique, contrôles qualité et instrumentation prête pour l’IA. La fondation de données dont dépend votre IA.",
      keywords: "plateforme données, données prêtes IA, pile de données moderne, couche sémantique",
    },
    industries: {
      title: "Industries — Systèmes IA par secteur | Vert AI",
      description: "Systèmes IA en production pour retail, CPG, franchises, services professionnels, B2B, comptabilite, fabrication et distribution.",
      keywords: "IA par industrie, IA retail, IA CPG, IA franchise, IA services professionnels, IA services B2B, IA comptabilite, IA manufacturier",
    },
    accounting: {
      title: "IA pour cabinets comptables — documents et revue | Vert AI",
      description: "Systèmes IA pour cabinets comptables : intelligence documentaire, revue de dossiers, accueil client, recherche de savoir et contrôles auditables.",
      keywords: "IA comptabilité, automatisation vérification, IA cabinet comptable, technologie CPA",
    },
    manufacturing: {
      title: "IA pour manufacturiers et distributeurs | Vert AI",
      description: "Prévision de la demande, planification de production, maintenance prédictive et optimisation de la chaîne d’approvisionnement. IA pour opérateurs industriels.",
      keywords: "IA manufacturier, IA distribution, prévision demande, maintenance prédictive, IA chaîne approvisionnement",
    },
    serviceBusinesses: {
      title: "IA pour entreprises de services et métiers | Vert AI",
      description: "Systèmes IA pour services : intake, planification, communication client, aide à l’estimation et suivi opérationnel.",
      keywords: "IA services professionnels, IA conseil, automatisation cabinet services",
    },
    ecommerce: {
      title: "IA pour le commerce en ligne et la croissance DTC | Vert AI",
      description: "Recommandation, prévision de la demande, mesure de rentabilité, automatisation du soutien et intelligence de catalogue pour opérateurs e-commerce et DTC.",
      keywords: "IA commerce en ligne, IA DTC, systèmes recommandation, automatisation e-commerce",
    },
    work: {
      title: "Schémas de travail sélectionnés | Preuves IA de production | Vert AI",
      description: "Explorez des schémas de travail honnêtes pour systèmes IA de production, automatisation de flux, fondations de données prêtes pour l’IA et flux décisionnels monitorés.",
      keywords: "schémas de travail, preuve IA de production, standards livraison IA, preuves automatisation flux",
    },
    aiReadinessScorecard: {
      title: "Scorecard de préparation IA pour flux de production | Vert AI",
      description: "Notez si un flux, une décision ou un problème de données est prêt pour l’IA de production et voyez quoi corriger avant de construire.",
      keywords: "scorecard préparation IA, préparation IA production, évaluation flux IA, score opportunité IA",
    },
    insights: {
      title: "Perspectives — Analyse stratégique IA et données | Vert AI",
      description: "Analyse de calibre opérationnel sur les systèmes IA, l’infrastructure de données et l’économie de la décision commerciale. Écrit pour opérateurs seniors.",
      keywords: "perspectives IA, stratégie IA, déploiement IA, analyse ingénierie données",
    },
    vetVendor: {
      title: "Comment évaluer un fournisseur IA — Guide acheteur | Vert AI",
      description: "Distinguez la vraie capacité IA du marketing soigné. Les questions, critères et signaux qui séparent les fournisseurs de production des boutiques de prototypes.",
      keywords: "évaluation fournisseur IA, achat IA, choisir consultant IA, guide acheteur IA",
    },
    productionGrade: {
      title: "Ce que signifie réellement « IA de production » | Vert AI",
      description: "Ce qui sépare une démo d’un système qui tourne en production. L’ingénierie, la surveillance, les plans de repli et la discipline opérationnelle requises.",
      keywords: "IA production, IA de calibre production, MLOps, déploiement IA",
    },
    workflowsDeserveAI: {
      title: "Quels processus méritent l’IA — Cadre de sélection | Vert AI",
      description: "Où l’IA crée de la valeur mesurable et où elle n’en crée pas. Un cadre diagnostique pour choisir les processus qui justifient l’investissement.",
      keywords: "sélection cas d’usage IA, ROI IA, critères automatisation, priorisation IA",
    },
    about: {
      title: "À propos de Vert AI | IA de production, données et décision",
      description: "Decouvrez comment Vert AI aide les opérateurs à construire des systèmes IA de production, plateformes de données, automatisations de flux et moteurs de décision.",
      keywords: "à propos Vert AI, systèmes IA de production, plateformes de données, systèmes décisionnels, Guillaume Belisle",
    },
    contact: {
      title: "Contact Vert AI | Appel de cadrage IA de production",
      description: "Discutez avec Vert AI de systèmes IA de production, automatisation de flux, plateformes de données et intelligence décisionnelle.",
      keywords: "contact Vert AI, appel cadrage IA production, automatisation flux IA, plateformes données, intelligence décisionnelle",
    },
    notFound: {
      title: "Page introuvable | Vert AI",
      description: "La page que vous cherchez n’existe pas ou a été déplacée.",
    },
    unsubscribe: {
      title: "Désabonnement | Vert AI",
      description: "Gérez vos préférences courriel.",
    },
  },
};
